export default {
  "Student Login": "Student Login",
  "Business Login": "Business Login",
  "Forgot Password?": "Forgot Password?",
  "Forgot Password": "Forgot Password",
  "Enter the email address linked to your account and we will send you a verification code.":
    "Enter the email address linked to your account and we will send you a verification code.",
  "SEND VERIFICATION CODE": "SEND VERIFICATION CODE",
  "VERIFY CODE": "VERIFY CODE",
  "Choose a password with at least 8 characters.":
    "Choose a password with at least 8 characters.",
  "Confirm New Password": "Confirm New Password",
  "RESET PASSWORD": "RESET PASSWORD",
  "Password reset successfully": "Password reset successfully",
  "Back to login": "Back to login",
  "signup.emailExisted": "Email already exists",
  "signup.usernameExisted": "Username already exists",
  "signup.invalidUniversityEmail": "Invalid university email",
  "signup.phoneExists": "This phone number is already registered to another account. Please use a different number.",
  "signup.phoneRequired": "Please enter your phone number.",
  "signup.invalidPhone": "That phone number doesn't look valid. Please check the number and country code, then try again.",
  "signup.hkPhoneMustBe8Digits": "Hong Kong phone numbers must be exactly 8 digits (for example 9123 4567). Please check the number and try again.",
  "signup.smsSendFailed": "We couldn't send the verification SMS. Please check your number and try again.",
  "My Coupons": "My Coupons",
  "Create New Coupon": "Create New Coupon",
  "No coupons": "No coupons",
  Search: "Search",
  Account: "Account",
  Guest: "Guest",
  "Create an account to join, save events, follow societies, share surveys and more?":
    "Create an account to join, save events, follow societies, share surveys and more?",
  "LOG IN NOW": "LOG IN NOW",
  "REGISTER NOW": "REGISTER NOW",
  Username: "Username",
  "Your University Email": "Your University Email",
  "Phone Number": "Phone Number",
  "Region Code": "Region Code",
  "Select your Region Code": "Select your Region Code",
  Password: "Password",
  "Confirmed Password": "Confirmed Password",
  REGISTER: "REGISTER",
  "ALREADY HAVE AN ACCOUNT?": "ALREADY HAVE AN ACCOUNT?",
  "Please fill in all the blank": "Please fill in all the blank",
  "Network error, please try again": "Network error, please try again",
  "Password must be at least 8 digits!": "Password must be at least 8 digits!",
  "Password and Confirmed Password are not match":
    "Password and Confirmed Password are not match",
  "Enter the verification code": "Enter the verification code",
  "Verification Code": "Verification Code",
  "RESEND VERIFICATION CODE": "RESEND VERIFICATION CODE",
  "Phone Verification": "Phone Verification",
  "Enter the SMS code sent to your phone": "Enter the SMS code sent to your phone",
  "SMS code": "SMS code",
  "SEND CODE": "SEND CODE",
  "Resend code": "Resend code",
  "Code verified": "Code verified",
  "Verify new phone number": "Verify new phone number",
  "Phone number changed successfully": "Phone number changed successfully",
  "Phone verification required": "Please verify your new phone number first.",
  "Phone number is not verified": "Phone number is not verified",
  "Saving...": "Saving...",
  "Sending...": "Sending...",
  "Verifying...": "Verifying...",
  VERIFY: "VERIFY",
  "Phone Existed": "Phone Existed",
  "Please verify your phone number": "Please verify your phone number",
  "Please enter the SMS code": "Please enter the SMS code",
  "Invalid verification code": "Invalid verification code",
  "Verification code expired, please resend": "Verification code expired, please resend",
  "Too many attempts, please resend": "Too many attempts, please resend",
  "Verification code already used, please resend":
    "Verification code already used, please resend",
  "SMS service not configured": "SMS service not configured",
  ENTER: "ENTER",
  OK: "OK",
  "Custom your Profile icon": "Custom your Profile icon",
  NEXT: "NEXT",
  SKIP: "SKIP",
  "Please select your profile icon": "Please select your profile icon",
  "Scan your university card": "Scan your university card",
  "Upload your university card": "Upload your university card",
  "Please select your student card": "Please select your student card",
  BACK: "BACK",
  "QR SCAN": "QR SCAN",
  "OPEN SCANNER": "OPEN SCANNER",
  "Invalid QR code": "Invalid QR code",
  "Please login": "Please login",
  University: "University",
  Gender: "Gender",
  Identity: "Identity",
  hku: "University of Hong Kong",
  hkust: "HKUST",
  cuhk: "The Chinese University of Hong Kong",
  polyu: "The Hong Kong Polytechnic University",
  hkbu: "Hong Kong Baptist University",
  cityu: "City University of Hong Kong",
  hksyu: "Hong Kong Shue Yan University",
  hkmu: "Hong Kong Metropolitan University",
  eduhk: "The Education University of Hong Kong",
  lingu: "Lingnan University",
  hkuspace: "HKU Space",
  tw_csmu: "Chung Shan Medical University",
  "Select your univesity": "Select your univesity",
  "Select your Gender": "Select your Gender",
  "Select your Identity": "Select your Identity",
  Undergraduate: "Undergraduate",
  Postgraduate: "Postgraduate",
  "Teaching Staff": "Teaching Staff",
  "Administrative or Research Staff": "Administrative or Research Staff",
  Alumni: "Alumni",
  Retiree: "Retiree",
  "Year one": "Year one",
  "Year Two": "Year Two",
  "Year Three": "Year Three",
  "Year Four": "Year Four",
  "Year Five": "Year Five",
  "Year Six": "Year Six",
  "Year Seven": "Year Seven",
  "Year Eight or above": "Year Eight or above",
  "Year Of Study*": "Year Of Study*",
  "Please select year of study": "Please select year of study",
  "Select Year Of Study": "Select Year Of Study",
  "Can`t register account": "Can`t register account",
  Setting: "Setting",
  Logout: "Logout",
  "EXPLORE NOW": "EXPLORE NOW",
  "REGISTERED SUCCESSFULLY": "REGISTERED SUCCESSFULLY",
  "Logout Now?": "Logout Now?",
  LOGOUT: "LOGOUT",
  LOGIN: "LOGIN",
  "LOG IN": "LOG IN",
  Following: "Following",
  Subscription: "Subscription",
  "EDIT PROFILE": "EDIT PROFILE",
  "SHARE PROFILE": "SHARE PROFILE",
  "Your Societies / Clubs*": "Your Societies / Clubs*",
  "Select your Societies / Clubs": "Select your Societies / Clubs",
  "Societies / Clubs": "Societies / Clubs",
  "Upload Event Image (max 10)": "Upload Event Image (max 10)",
  "Title*": "Title*",
  Description: "Description",
  "Description (optional)": "Description (optional)",
  Location: "Location",
  "Location (optional)": "Location (optional)",
  "Max. 20 HashTags": "Max. 20 HashTags",
  "Please Input Email": "Please Input Email",
  "Invalid Email": "Invalid Email",
  "Invalid Phone Number": "Invalid Phone Number",
  "Please Input Link": "Please Input Link",
  "Please Input Event Title": "Please Input Event Title",
  "Please Select Event Society": "Please Select Event Society",
  "Choose...": "Choose...",
  "Date & Time*": "Date & Time*",
  "Application Deadline": "Application Deadline",
  "Allow User to apply the activity through Uninfo":
    "Allow User to apply the activity through Uninfo",
  "Event Targets": "Event Targets",
  "UPLOAD EVENT": "UPLOAD EVENT",
  "Bachelor degree": "Bachelor degree",
  "Year of study": "Year of study",
  "Never Repeat": "Never Repeat",
  "Daily Repeat": "Daily Repeat",
  "Weekly Repeat": "Weekly Repeat",
  "End Time On": "End Time On",
  "Repeat Daily or Weekly?": "Repeat Daily or Weekly?",
  "Daily Repeat until": "Daily Repeat until",
  "Weekly Repeat until": "Weekly Repeat until",
  "JOIN EVENT NOW": "JOIN EVENT NOW",
  "APPLICATION DATE - ": "APPLICATION DATE - ",
  "JOIN THIS EVENT": "JOIN THIS EVENT",
  "YOU WILL BE NOTIFIED": "YOU WILL BE NOTIFIED",
  "WHEN YOUR ELIGIBILITY IS CONFIRMED": "WHEN YOUR ELIGIBILITY IS CONFIRMED",
  "You are not eligible": "You are not eligible",
  "UNJOIN EVENT": "UNJOIN EVENT",
  "UNJOIN THIS EVENT": "UNJOIN THIS EVENT",
  "UNJOIN THIS EVENT ?": "UNJOIN THIS EVENT ?",
  "APPLICATION REJECTRED": "APPLICATION REJECTRED",
  "APPLICATION ACCEPTED": "APPLICATION ACCEPTED",
  Calendar: "Calendar",
  FOLLOW: "FOLLOW",
  FOLLOWING: "FOLLOWING",
  ALL: "ALL",
  "WELCOME TO JOIN": "WELCOME TO JOIN",
  FINISHED: "FINISHED",
  JOINED: "JOINED",
  "IN PROCESS": "IN PROCESS",
  "CREATE YOUR SURVEY": "CREATE YOUR SURVEY",
  Rewards: "Rewards",
  "Enhance the allure of this survey by penning down your desired reward":
    "Enhance the allure of this survey by penning down your desired reward",
  "Please Fill In The Title": "Please Fill In The Title",
  "UPLOAD SURVEY": "UPLOAD SURVEY",
  "Question Type": "Question Type",
  "Select your question type": "Select your question type",
  "Your Question": "Your Question",
  number: "number",
  Number: "Number",
  now: "now",
  Question: "Question",
  PREVIOUS: "PREVIOUS",
  REWARDS: "REWARDS",
  "GIVING REWARDS": "GIVING REWARDS",
  "GIVING REWARDS?": "GIVING REWARDS?",
  "CONTACT PARTICIPANT": "CONTACT PARTICIPANT",
  Published: "Published",
  "Expire in": "Expire in",
  EXPIRED: "EXPIRED",
  PARTICIPANTS: "PARTICIPANTS",
  "EDIT EVENT": "EDIT EVENT",
  "Edit Profile": "Edit Profile",
  "APPLICATION PROCESSING": "APPLICATION PROCESSING",
  "BOOKING FULL": "BOOKING FULL",
  "Login To Explore More": "Login To Explore More",
  "Manage Society": "Manage Society",
  "English Name": "English Name",
  "Chinese Name": "Chinese Name",
  "Delete Event?": "Delete Event?",
  Delete: "Delete",
  "Target Year Of Study": "Target Year Of Study",
  Redeem: "Redeem",
  "Coupon Icon": "Coupon Icon",
  "Redeem Coupons": "Redeem Coupons",
  "Quatity*": "Quatity*",
  Quatity: "Quatity",
  "ADD NOW": "ADD NOW",
  "Redeem Coupon?": "Redeem Coupon?",
  "No terms":
    "Any terms and final interpretation shall be determined by UninfoHK. In case of any dispute, UninfoHK's decision shall be final. This offer is subject to the applicable laws and regulations of the Hong Kong SAR.",
  "Not Enough Point": "Not Enough Point",
  "Use It Now?": "Use It Now?",
  "Use It Now": "Use It Now",
  "Joined Society": "Joined Society",
  Tasks: "Tasks",
  "Brief the tasks that you need the university student to complete":
    "Brief the tasks that you need the university student to complete",
  FREE: "FREE",
  "Add Member": "Add Member",
  "New Member University Email": "New Member University Email",
  "Remove Member?": "Remove Member?",
  Remove: "Remove",
  "Get Your Coupon Code In Chat Room": "Get Your Coupon Code In Chat Room",
  "Change Password": "Change Password",
  "Old Password": "Old Password",
  "New Password": "New Password",
  "The old password is not correct": "The old password is not correct",
  Enquiry: "Enquiry",
  "Complete Survey To Earn 10 Points": "Complete Survey To Earn 10 Points",
  "Join Activity To Earn 20 Points": "Join Activity To Earn 20 Points",
  "Redeem The Coupon Successfully": "Redeem The Coupon Successfully",
  "Scan To Use The Coupon Successfully": "Scan To Use The Coupon Successfully",
  "Need To Complete Tasks": "Need To Complete Tasks",
  "Contact Business": "Contact Business",
  "Contact Business?": "Contact Business?",
  "Get Promo Code": "Get Promo Code",
  "Please upload your student card": "Please upload your student card",
  "Registration Code (optional)": "Registration Code (optional)",
  "Registration Code Is Not Valid": "Registration Code Is Not Valid",
  "Sponsor Activity": "Sponsor Activity",
  "Society Instagram Name": "Society Instagram Name",
  "Society Instagram Followers": "Society Instagram Followers",
  "Activity Name": "Activity Name",
  "Quantity Of Participants": "Quantity Of Participants",
  "You are not eligible to redeem sponsor":
    "You are not eligible to redeem sponsor",
  "Request To Redeem Sponsor Successfully. Please Wait For Sponsor Provider To Accept Your Request":
    "Request To Redeem Sponsor Successfully. Please Wait For Sponsor Provider To Accept Your Request",
  SPONSORS: "SPONSORS",
  "Activity Title": "Activity Title",
  Participants: "Participants",
  "Please Input Task": "Please Input Task",
  "ADD TASKS": "ADD TASKS",
  "ASSIGN TO SOCIETY NOW": "ASSIGN TO SOCIETY NOW",
  "Assign To Society?": "Assign To Society?",
  "Once you assign to society. You can`t edit or add the tasks":
    "Once you assign to society. You can`t edit or add the tasks",
  UPLOAD: "UPLOAD",
  "ADD PHOTOS": "ADD PHOTOS",
  "PLEASE WAIT FOR TASKS": "PLEASE WAIT FOR TASKS",
  "Please Add Tasks": "Please Add Tasks",
  "Wait For Society To Accept Your Tasks":
    "Wait For Society To Accept Your Tasks",
  "Waiting For Check": "Waiting For Check",
  "Check Tasks Now": "Check Tasks Now",
  "Society Has Not Yet Uploaded Task Prove":
    "Society Has Not Yet Uploaded Task Prove",
  "Images as verification of the completed task":
    "Images as verification of the completed task",
  "Activity Start Date": "Activity Start Date",
  "Valid Duration": "Valid Duration",
  "Start time": "Start time",
  "End time": "End time",
  "Coupon Category": "Coupon Category",
  "Discount Coupon": "Discount coupon",
  "Buy 1 Get 1 Free": "Buy 1 get 1 free",
  "Free Item": "Free item",
  "Free Shipping": "Free shipping",
  Cashback: "Cashback",
  "This coupon type is coming soon": "This coupon type is coming soon",
  "Set buy quantity and free quantity": "Set buy quantity and free quantity",
  "Buy Quantity": "Buy quantity",
  "Free Quantity": "Free quantity",
  "Coupon Type": "Coupon Type",
  "Coupons can only discount the price of items":
    "Coupons can only discount the price of items",
  "% Off": "% Off",
  "Amount Off": "Amount Off",
  "Discount amount": "Discount amount",
  "Redeem Times per user": "Redeem times per user",
  "Redeem Times per coupon": "Redeem times per coupon",
  "Issued Quantity": "Issued Quantity",
  "Redeem Times & Issued Quantity": "Redeem Times & Issued Quantity",
  "Offer Details": "Offer Details",
  "Generated Terms": "Generated Terms",
  "Preview Terms & Conditions": "Preview Terms & Conditions",
  "Please fill in Offer Details":
    "Please complete the Offer Details section below.",
  "Extra Terms (Optional)": "Extra Terms (Optional)",
  "Free Shipping has no extra details": "Free shipping has no extra details",
  "Cashback amount": "Cashback amount",
  "Free Item Details": "Free item details",
  "Bundle / Package": "Bundle / package",
  "Bundle Details": "Bundle details",
  "Time-slot Deal": "Time-slot deal",
  "Time-slot Deal Details": "Time-slot deal details",
  "Group Deal": "Group deal",
  "Minimum people": "Minimum people",
  "Group Deal Details": "Group deal details",
  "Reservation Discount": "Reservation discount",
  "Advance booking days": "Advance booking days",
  "Reservation Discount Details": "Reservation discount details",
  "Free Upgrade": "Free upgrade",
  "Free Upgrade Details": "Free upgrade details",
  "Add-on Deal": "Add-on deal",
  "Add-on Deal Details": "Add-on deal details",
  "Points Multiplier": "Points multiplier",
  "Birthday Special": "Birthday special",
  "Birthday Special Details": "Birthday special details",
  "Deposit Waiver": "Deposit waiver",
  "Deposit Waiver Details": "Deposit waiver details",
  "First-time Deal": "First-time deal",
  "First-time Deal Details": "First-time deal details",
  Terms_Discount_Percent: "{{value}}% off",
  Terms_Discount_Amount: "HK$ {{value}} off",
  Terms_Cashback_Percent: "{{value}}% cashback",
  Terms_Cashback_Amount: "HK$ {{value}} cashback",
  Terms_BOGO: "Buy {{buy}} get {{get}} free",
  Terms_FreeItem: "Free item: {{detail}}",
  Terms_FreeShipping: "Free shipping",
  Terms_Bundle: "Bundle deal: {{detail}}",
  Terms_TimeSlotDeal: "Valid {{start}}–{{end}}: {{detail}}",
  Terms_GroupDeal: "Group of {{min}}+: {{detail}}",
  Terms_ReservationDiscount: "Book {{days}}+ days in advance: {{detail}}",
  Terms_FreeUpgrade: "Free upgrade: {{detail}}",
  Terms_AddOn: "Add-on deal: {{detail}}",
  Terms_PointsMultiplier: "{{multiplier}}x points",
  Terms_Birthday: "Birthday special: {{detail}}",
  Terms_DepositWaiver: "Deposit waiver: {{detail}}",
  Terms_FirstTime: "First-time deal: {{detail}}",
  Terms_ExpiryDate: "Expiry date: {{date}}",
  Terms_ExpiryPeriodDays: "Valid for {{days}} day(s)",
  Terms_UninfohkOfficialLaw:
    "Any terms and final interpretation shall be determined by UninfoHK. In case of any dispute, UninfoHK's decision shall be final. This offer is subject to the applicable laws and regulations of the Hong Kong SAR.",
  "Expiry Date": "Expiry Date",
  "Expiry Period (days)": "Expiry Period (days)",
  "Original Price": "Original Price",
  "Original Price (HKD)": "Original Price (HKD)",
  "Offer suspended": "Offer suspended",
  "This offer is suspended and cannot be redeemed right now.":
    "This offer is suspended and cannot be redeemed right now.",
  "Coupon Price": "Coupon Price",
  "Coupon Discount Price": "Coupon Discount Price",
  "Coupon Name": "Coupon Name",
  "Coupon Terms": "Coupon Terms",
  "How to use": "How to use",
  "Maximum limit (Optional)": "Maximum limit (Optional)",
  "Coupon Information": "Coupon Information",
  "Please Try Again": "Please Try Again",
  "Can't Update Access Token": "Can't Update Access Token",
  "Email Existed": "Email Existed",
  "Username Existed": "Username Existed",
  "Can't Register Account": "Can't Register Account",
  "Email Not Registered": "Email Not Registered",
  "Invalid Password": "Invalid Password",
  "Account Is Not Active": "Account Is Not Active",
  // Sent by the server as the -40022 chat-send-denial / auto-sign-out message.
  "Business account is not active": "Business account is not active",
  "Can`t Upload Event": "Can't Upload Event",
  "Can`t Unsubscript Event": "Can't Unsubscript Event",
  "Can`t Follow Organizer": "Can't Follow Organizer",
  "Can`t Unfollow Organizer": "Can't Unfollow Organizer",
  "Can`t Redeem Coupon": "Can`t Redeem Coupon",
  "Not Enough Coupon To Redeem": "Not Enough Coupon To Redeem",
  ACCEPT: "ACCEPT",
  "ACCEPT TASKS NOW": "ACCEPT TASKS NOW",
  ACCEPTED: "ACCEPTED",
  ADD: "ADD",
  "ADD MEMBER": "ADD MEMBER",
  "ADD QUESTION": "ADD QUESTION",
  "ADD TASKS NOW": "ADD TASKS NOW",
  "APPLICATION DEADLINE - ": "APPLICATION DEADLINE - ",
  ASSIGN: "ASSIGN",
  "Accept The Tasks?": "Accept The Tasks?",
  "Activity Description": "Activity Description",
  "Activity Description*": "Activity Description*",
  "Activity Location": "Activity Location",
  "Activity Photo": "Activity Photo",
  Add: "Add",
  "Add Tag for the activity (It will assigned to the elements that you want to search with)":
    "Add Tag for the activity (It will assigned to the elements that you want to search with)",
  All: "All",
  "Application Deadline: ": "Application Deadline: ",
  "Application Rejected": "Application Rejected",
  "Assignt Tasks Now": "Assignt Tasks Now",
  "BACHELOR DEGREE": "BACHELOR DEGREE",
  "Basic Information": "Basic Information",
  CANCEL: "CANCEL",
  COMPLETE: "COMPLETE",
  COMPLETED: "COMPLETED",
  CONFIRM: "CONFIRM",
  CONTINUE: "CONTINUE",
  "CREATE NOW": "CREATE NOW",
  "Camera permission is required.": "Camera permission is required.",
  "Can`t Accept Sponsor Tasks": "Can`t Accept Sponsor Tasks",
  "Can`t Assign Sponsor Tasks To Society":
    "Can`t Assign Sponsor Tasks To Society",
  "Can`t Change Password": "Can`t Change Password",
  "Can`t Complete All Sponsor Tasks": "Can`t Complete All Sponsor Tasks",
  "Can`t Complete Sponsor Task": "Can`t Complete Sponsor Task",
  "Can`t Create Sponsor Activity": "Can`t Create Sponsor Activity",
  "Can`t Create Survey": "Can`t Create Survey",
  "Can`t Delete Event": "Can`t Delete Event",
  "Can`t Edit Event": "Can`t Edit Event",
  "Can`t Edit Profile": "Can`t Edit Profile",
  "Can`t Get Chat Room": "Can`t Get Chat Room",
  "Can`t Get Organizer": "Can`t Get Organizer",
  "Can`t Get Score": "Can`t Get Score",
  "Can`t Get Society Members": "Can`t Get Society Members",
  "Can`t Get User": "Can`t Get User",
  "Can`t Give Rewards": "Can`t Give Rewards",
  "Can`t Join Event": "Can`t Join Event",
  "Can`t Redeem Sponsor": "Can`t Redeem Sponsor",
  "Can`t Remove Society Member": "Can`t Remove Society Member",
  "Can`t Unjoin Event": "Can`t Unjoin Event",
  "Can`t Upload Sponsor Tasks Prove": "Can`t Upload Sponsor Tasks Prove",
  "Can`t Use Redeemed Coupons": "Can`t Use Redeemed Coupons",
  Chat: "Chat",
  "Chinese Names": "Chinese Names",
  "Coupon Does Not Belong To This Account":
    "Coupon Does Not Belong To This Account",
  "Create Activity": "Create Activity",
  "Create Activity Now !!!": "Create Activity Now !!!",
  Created: "Created",
  "Custom Repeat": "Custom Repeat",
  DashBoard: "DashBoard",
  Date: "Date",
  "Deadline Date & Time*": "Deadline Date & Time*",
  "Description for the First Number": "Description for the First Number",
  "Description for the Second Number": "Description for the Second Number",
  "Don`t repeat": "Don`t repeat",
  EDIT: "EDIT",
  EMAIL: "EMAIL",
  "EVENT ENDED": "EVENT ENDED",
  Edit: "Edit",
  Email: "Email",
  "End Date": "End Date",
  "End Time": "End Time",
  "Enhance the allure of this survey by penning down your desired reward.":
    "Enhance the allure of this survey by penning down your desired reward.",
  FILTER: "FILTER",
  FINISH: "FINISH",
  Fee: "Fee",
  "Fill in your option": "Fill in your option",
  Free: "Free",
  GENDER: "GENDER",
  Give: "Give",
  "Grant Permission": "Grant Permission",
  "HIDE EVENT TARGET": "HIDE EVENT TARGET",
  "HashTag (max 20.)": "HashTag (max 20.)",
  IDENTITY: "IDENTITY",
  "Infinity Quantity": "Infinity Quantity",
  "Invalid New Password": "Invalid New Password",
  JOIN: "JOIN",

  "Join Activity": "Join Activity",
  "Join Activity Now !!!": "Join Activity Now !!!",
  Joining: "Joining",
  Link: "Link",
  "Location*": "Location*",
  Login: "Login",
  "MORE DETAILS": "MORE DETAILS",
  "Max Participants": "Max Participants",
  "Max Participants*": "Max Participants*",
  "Meeting Date & Time*": "Meeting Date & Time*",
  "Meeting Date: ": "Meeting Date: ",
  "Meeting Location": "Meeting Location",
  "Meeting Location*": "Meeting Location*",
  "No Any Incompleted Sponsor Tasks": "No Any Incompleted Sponsor Tasks",
  "No Participants": "No Participants",
  Notification: "Notification",
  "Once you accept the tasks. You must complete the tasks":
    "Once you accept the tasks. You must complete the tasks",
  "Once you click complete the task. You cannot return your action":
    "Once you click complete the task. You cannot return your action",
  "Owner of the email (optional)": "Owner of the email (optional)",
  "Owner of the phone number (optional)":
    "Owner of the phone number (optional)",
  POINTS: "POINTS",
  "People Joined": "People Joined",
  Phone: "Phone",
  "Phone number": "Phone number",
  "Please Accept The Tasks": "Please Accept The Tasks",
  "Please Complete The Tasks": "Please Complete The Tasks",
  "Please Fill In Title": "Please Fill In Title",
  "Please Input Phone Number": "Please Input Phone Number",
  "Please Input Tag": "Please Input Tag",
  "Please Select Event End Date": "Please Select Event End Date",
  "Please Select Event Start Date": "Please Select Event Start Date",
  "Please upload images as verification of the completed task":
    "Please upload images as verification of the completed task",
  "Please use university email": "Please use university email",
  Quantity: "Quantity",
  "Quantity Of Sponsors": "Quantity Of Sponsors",
  "Quantity*": "Quantity*",
  "REDEEM COUPONS": "REDEEM COUPONS",
  REJECT: "REJECT",
  REJECTED: "REJECTED",
  REMOVE: "REMOVE",
  "Redeem Point*": "Redeem Point*",
  "Redeem Poiunt": "Redeem Poiunt",
  "Redeem to get Promo Code \\n\\n": "Redeem to get Promo Code \\n\\n",
  "Redeemed Coupon Not Existed": "Redeemed Coupon Not Existed",
  "Redeemed Coupon Was Used": "Redeemed Coupon Was Used",
  "Remove the task?": "Remove the task?",
  "SHOW EVENT TARGET": "SHOW EVENT TARGET",
  START: "START",
  "Search for users (optional)": "Search for users (optional)",
  "Select your University": "Select your University",
  "Select your Year Of Study": "Select your Year Of Study",
  "Select your year of study": "Select your year of study",
  Signup: "Signup",
  "Start Date": "Start Date",
  "Start Time": "Start Time",
  Statistics: "Statistics",
  Subscripted: "Subscripted",
  "Survey Targets": "Survey Targets",
  "TASK COMPLETED": "TASK COMPLETED",
  Tag: "Tag",
  "Target Gender": "Target Gender",
  "Target Identity": "Target Identity",
  Task: "Task",
  "Task Completed": "Task Completed",
  "Task completed?": "Task completed?",
  "Tasks Accepted": "Tasks Accepted",
  "Tasks Assigned": "Tasks Assigned",
  "Tasks Completed": "Tasks Completed",
  Title: "Title",
  "Title of the link (optional)": "Title of the link (optional)",
  UNIVERSITY: "UNIVERSITY",
  UNJOIN: "UNJOIN",
  UPDATE: "UPDATE",
  USED: "USED",
  USERNAME: "USERNAME",
  "Uninfo will verify your university card in 24 hrs":
    "Uninfo will verify your university card in 24 hrs",
  "University Email": "University Email",
  "Upload Prove Now": "Upload Prove Now",
  "Uploaded Prove": "Uploaded Prove",
  "User Can Only Redeem The Coupon Once":
    "User Can Only Redeem The Coupon Once",
  "User Is Not Existerd": "User Is Not Existerd",
  "Wait For Soceity": "Wait For Soceity",
  "Wait For Tasks": "Wait For Tasks",
  "YEAR OF STUDY": "YEAR OF STUDY",
  "Year Of Study": "Year Of Study",
  YearOfStudy: "YearOfStudy",
  choose: "choose",
  email: "email",
  please_fill_in_all_the_blank: "please_fill_in_all_the_blank",
  please_try_again: "please_try_again",
  s: "s",
  upload_poster: "upload_poster",
  "MONTHLY STATEMENT": "MONTHLY STATEMENT",
  Year: "Year",
  "Platform Fee": "Platform Fee",
  "Total Fees": "Total Fees",
  "What you're paying for": "What you're paying for",
  "Coupon Shortfall": "Coupon Shortfall",
  "Platform fee (free first year)": "Platform fee (free first year)",
  "No charge yet — assessed after the month ends": "No charge yet — assessed after the month ends",
  "{{count}} of {{required}} new coupon required — charged in {{month}}": "{{count}} of {{required}} new coupon required — charged in {{month}}",
  "{{count}} of required new coupon published": "{{count}} of required new coupon published",
  "Free first year (First 100)": "Free first year (First 100)",
  "until {{date}}": "until {{date}}",
  "Monthly plan": "Monthly plan",
  "Yearly plan": "Yearly plan",
  "Renewal cancelled": "Renewal cancelled",
  Manage: "Manage",
  "Coupons Used": "Coupons Used",
  "Coupons Redeemed": "Coupons Redeemed",
  Payment: "Payment",
  "Pay by Bank Transfer": "Pay by Bank Transfer",
  "Pay by PayMe": "Pay by PayMe",
  "Bank Name": "Bank Name",
  "Account Name": "Account Name",
  "Account Number": "Account Number",
  "Tap any field to copy": "Tap any field to copy",
  Copied: "Copied",
  "Copy PayMe Link": "Copy PayMe Link",
  "PayMe is not configured": "PayMe is not configured",
  Expand: "Expand",
  Collapse: "Collapse",
  "Copy Receipt Link": "Copy Receipt Link",
  "No receipt uploaded": "No receipt uploaded",
  "Receipt uploaded": "Receipt uploaded",
  "Receipt upload failed": "Receipt upload failed",
  "Uploading...": "Uploading...",
  "Please enable photo access": "Please enable photo access",
  "Please select an image": "Please select an image",
  Month: "Month",
  "No statement for this month": "No statement for this month",
  "This feature is for business accounts only":
    "This feature is for business accounts only",
  "Can`t Fetch Monthly Statement": "Can`t Fetch Monthly Statement",
  Record: "Record",
  "Business: scan customer coupon": "Business: scan customer coupon",
  "User: scan to redeem coupon": "User: scan to redeem coupon",
  "Scan customer coupon QR to use": "Scan customer coupon QR to use",
  "Scan QR to redeem coupon": "Scan QR to redeem coupon",
  "Ask customer to show QR": "Ask customer to show QR",
  "After success, coupon will be used": "After success, coupon will be used",
  "After success, points will be deducted":
    "After success, points will be deducted",
  "Scan QR Code": "Scan QR Code",
  "Align QR code within frame": "Align the QR code within the frame",
  "Only partner shops can scan this QR code":
    "Only partner shops can scan this QR code.",
  "This QR code must be scanned by a partner shop":
    "Scan to use. This QR code must be scanned by a partner shop.",
  "Business Email": "Business Email",
  Coupon: "Coupon",
  "No sponsors": "No sponsors",
  "Sponsors are set up by UninfoHK.": "Sponsors are set up by UninfoHK.",
  "Sponsors are managed by UninfoHK.": "Sponsors are managed by UninfoHK.",
  "Sponsor the community with UninfoHK": "Sponsor the community with UninfoHK",
  "Chat with UninfoHK to learn how to sponsor the community and promote your brand.":
    "Chat with UninfoHK to learn how to sponsor the community and promote your brand.",
  "Log in with an authorized account to view this section, or chat with us to request a sponsor.":
    "Log in with an authorized account to view this section, or chat with us to request a sponsor.",
  "Chat with UninfoHK": "Chat with UninfoHK",
  "Want to sponsor students?": "Want to sponsor students?",
  "Chat with UninfoHK to request a sponsor. Tell us what you'd like to sponsor and the tasks students should complete.":
    "Chat with UninfoHK to request a sponsor. Tell us what you'd like to sponsor and the tasks students should complete.",
  "UninfoHK sets up the sponsor and assigns it to your account. It then appears here.":
    "UninfoHK sets up the sponsor and assigns it to your account. It then appears here.",
  "Students and societies redeem it and submit proof. Track their progress in the Task Completions tab.":
    "Students and societies redeem it and submit proof. Track their progress in the Task Completions tab.",
  "Create New Sponsor": "Create New Sponsor",
  "Sponsor Name": "Sponsor Name",
  "Sponsor Description": "Sponsor Description",
  "Sponsor Image": "Sponsor Image",
  "Pick an image": "Pick an image",
  "Sponsor Tasks": "Sponsor Tasks",
  "Both the official society Instagram account and each committee account must follow the accounts and like all posts for 1 year. If already done, recruit others to fulfill.":
    "Both the official society Instagram account and each committee account must follow the accounts and like all posts for 1 year. If already done, recruit others to fulfill.",
  "Instagram account": "Instagram account",
  "Add account": "Add account",
  "Ensure X students (not committee, not already followers) follow all accounts for 1 year.":
    "Ensure X students (not committee, not already followers) follow all accounts for 1 year.",
  "Number of students": "Number of students",
  "Committee must download and register for the Uninfo HK app. If already registered, recruit another student who has not registered to do so.":
    "Committee must download and register for the Uninfo HK app. If already registered, recruit another student who has not registered to do so.",
  "Publish one Story and Post, tagging @uninfohk and @we2tech, expressing gratitude to the Sponsor Provider and promoting the Uninfo HK platform. The official account Post is subject to prior written approval by the Sponsor Provider and must remain published and visible for at least one (1) year to ensure continuous compliance with this obligation.":
    "Publish one Story and Post, tagging @uninfohk and @we2tech, expressing gratitude to the Sponsor Provider and promoting the Uninfo HK platform. The official account Post is subject to prior written approval by the Sponsor Provider and must remain published and visible for at least one (1) year to ensure continuous compliance with this obligation.",
  "Custom sponsor task (optional)": "Custom sponsor task (optional)",
  "Add custom task": "Add custom task",
  "Create Sponsor": "Create Sponsor",
  "Delete Sponsor": "Delete Sponsor",
  "Delete Sponsor Confirm":
    "Are you sure you want to delete this sponsor? It will no longer be shown to students for new redemptions.",
  "Sponsor Deleted": "Sponsor deleted.",
  "Coupons & Sponsors": "Coupons & Sponsors",
  empty_coupon_title: "No available coupons",
  empty_coupon_subtitle:
    "Don't worry! We have lots of great coupons for you to explore.",
  empty_sponsor_title: "No available sponsors",
  empty_sponsor_subtitle:
    "Don't worry! We have lots of great sponsors for you to explore.",
  empty_data_title: "No data available",
  "Redeem as:": "Redeem as:",
  Personal: "Personal",
  Society: "Society",
  Cancel: "Cancel",
  Failed: "Failed",
  sponsor_tasks: "Sponsor Tasks",
  loading: "Loading...",
  no_sponsor_tasks_found: "No sponsor tasks found.",
  days_left: "days left",
  deadline: "Deadline",
  in_store_use: "In-store Use",
  redeemed: "Redeemed",
  status_completed: "Status: Completed",
  status_incomplete: "Status: Incomplete",
  "No userId provided.": "No userId provided.",
  "Missing userId for sponsor tasks.": "Missing userId for sponsor tasks.",
  "Server error: Failed to fetch sponsor tasks.":
    "Server error: Failed to fetch sponsor tasks.",
  "Error: Unknown error.": "Error: Unknown error.",
  "Failed to load sponsor tasks.": "Failed to load sponsor tasks.",
  task: "Task",
  "Mark all as read": "Mark all as read",
  Completed: "Completed",
  "Auto-failed by bot": "Auto-failed by bot",
  "Auto-failed": "Auto-failed",
  Reviewing: "Reviewing",
  "Awaiting re-submit": "Awaiting re-submit",
  "Awaiting check": "⏳ Awaiting check",
  "Proof submitted": "Proof submitted",
  Pending: "Pending",
  "Verified by bot": "Verified by bot",
  "Auto-checked by bot": "Auto-checked by bot",
  Error: "Error",
  "Failed to approve.": "Failed to approve.",
  "Please enter a reason.": "Please enter a reason.",
  "Failed to reject.": "Failed to reject.",
  "HKD ${{amount}}": "HKD ${{amount}}",
  "Failed to fetch sponsor activities": "Failed to fetch sponsor activities",
  "No Compensation": "No Compensation",
  "Receipt Approved": "Receipt Approved",
  "Receipt Rejected": "Receipt Rejected",
  "Receipt Pending": "Receipt Pending",
  "Compensation: HKD ${{amount}}": "Compensation: HKD ${{amount}}",
  "Compensation Required": "Compensation Required",
  "Review in progress by AI...": "Review in progress by AI...",
  "Awaiting review": "Awaiting review",
  "Input IG Accounts": "Input IG Accounts",
  "Review Task": "Review Task",
  "Username: {{value}}": "Username: {{value}}",
  "Input Username": "Input Username",
  "Upload Video": "Upload Video",
  "Upload Image/Video": "Upload Image/Video",
  "Official Deadline for All Tasks: {{date}}":
    "Official Deadline for All Tasks: {{date}}",
  "You can upload proof or review your task from 1 week before the deadline until the deadline.\nIf you submit at least one proof before the deadline, you will have an extra 7-day cure period after the deadline to upload or review.":
    "You can upload proof or review your task from 1 week before the deadline until the deadline.\nIf you submit at least one proof before the deadline, you will have an extra 7-day cure period after the deadline to upload or review.",
  "Note: If you did not upload any proof before or on the deadline ({{date}}), there is NO cure period after the deadline.":
    "Note: If you did not upload any proof before or on the deadline ({{date}}), there is NO cure period after the deadline.",
  "You must submit at least one proof before the deadline to be eligible for the 7-day cure period after the deadline.":
    "You must submit at least one proof before the deadline to be eligible for the 7-day cure period after the deadline.",
  "According to the agreement, you have failed the task and are required to pay compensation.":
    "According to the agreement, you have failed the task and are required to pay compensation.",
  "Cure Period: {{start}} to {{end}} (7 days after deadline)\n\nYou may upload or review your task only if you submitted proof before the deadline.":
    "Cure Period: {{start}} to {{end}} (7 days after deadline)\n\nYou may upload or review your task only if you submitted proof before the deadline.",
  "Compensation Receipt": "Compensation Receipt",
  "Your compensation receipt has been approved.":
    "Your compensation receipt has been approved.",
  "Your compensation receipt was rejected. Please upload a new valid receipt.":
    "Your compensation receipt was rejected. Please upload a new valid receipt.",
  "Reason: {{reason}}": "Reason: {{reason}}",
  "Your compensation receipt is under review.":
    "Your compensation receipt is under review.",
  "Compensation due: HKD ${{amount}}": "Compensation due: HKD ${{amount}}",
  "You must upload a compensation receipt.\nThe receipt must clearly show:\n- The name of the recipient\n- The date of payment\n- The name of the person paying the compensation":
    "You must upload a compensation receipt.\nThe receipt must clearly show:\n- The name of the recipient\n- The date of payment\n- The name of the person paying the compensation",
  Upload: "Upload",
  "Receipt uploaded successfully!": "Receipt uploaded successfully!",
  "Task {{index}}": "Task {{index}}",
  "Review Failure Reason": "Review Failure Reason",
  "You have failed this task due to missing proof after the cure period.":
    "You have failed this task due to missing proof after the cure period.",
  "✅ Completed": "✅ Completed",
  "❌ Failed": "❌ Failed",
  "⏳ Incomplete": "⏳ Incomplete",
  "· Awaiting re-submit": "· Awaiting re-submit",
  Warning: "Warning",
  "Missing sponsor task ID.": "Missing sponsor task ID.",
  Info: "Info",
  "No changes detected.": "No changes detected.",
  Success: "Success",
  "Usernames saved successfully!": "Usernames saved successfully!",
  "Missing Parameter": "Missing Parameter",
  "Failed to save usernames: Missing required parameter.":
    "Failed to save usernames: Missing required parameter.",
  "Database Error": "Database Error",
  "Database error: {{error}} (code: {{code}})":
    "Database error: {{error}} (code: {{code}})",
  "Server Error": "Server Error",
  "Failed to save usernames. Please try again later.":
    "Failed to save usernames. Please try again later.",
  "Failed to save usernames: {{error}} (code: {{code}})":
    "Failed to save usernames: {{error}} (code: {{code}})",
  "Unknown Error": "Unknown Error",
  "Failed to save usernames: Unknown error":
    "Failed to save usernames: Unknown error",
  "Failed to save registered usernames.":
    "Failed to save registered usernames.",
  "Review attempts: {{count}} / 3": "Review attempts: {{count}} / 3",
  "You have failed 3 times. There is no extra opportunity for you to complete this task.":
    "You have failed 3 times. There is no extra opportunity for you to complete this task.",
  "Proof submitted successfully!": "Proof submitted successfully!",
  "Failed to submit proof: Missing required parameter.":
    "Failed to submit proof: Missing required parameter.",
  "Failed to store sponsor task proof. Please try again later.":
    "Failed to store sponsor task proof. Please try again later.",
  "Failed to submit proof: {{error}} (code: {{code}})":
    "Failed to submit proof: {{error}} (code: {{code}})",
  "Failed to submit proof: Unknown error":
    "Failed to submit proof: Unknown error",
  "Failed to review ensure_followers task.":
    "Failed to review ensure_followers task.",
  "No tasks found.": "No tasks found.",
  "Did not upload any proof for this task.":
    "Did not upload any proof for this task.",
  "Permission Required": "Permission Required",
  "Please grant media library access to upload a compensation receipt.":
    "Please grant media library access to upload a compensation receipt.",
  "Failed to open image picker. Please try again.":
    "Failed to open image picker. Please try again.",
  "Upload Failed": "Upload Failed",
  "Failed to upload receipt image to CDN. Please try again.":
    "Failed to upload receipt image to CDN. Please try again.",
  "Failed to upload compensation receipt. Please try again.":
    "Failed to upload compensation receipt. Please try again.",
  "Missing or invalid sponsor activity. Please contact support.":
    "Missing or invalid sponsor activity. Please contact support.",
  "Missing or invalid compensation receipt image.":
    "Missing or invalid compensation receipt image.",
  "Missing or invalid compensation amount.":
    "Missing or invalid compensation amount.",
  "Sponsor activity not found.": "Sponsor activity not found.",
  "Foreign key constraint failed. Please contact support.":
    "Foreign key constraint failed. Please contact support.",
  "Failed to upload compensation receipt. Please try again later.":
    "Failed to upload compensation receipt. Please try again later.",
  "Compensation receipt uploaded!": "Compensation receipt uploaded!",
  "Reminder: The second review attempt can only be made on or after the deadline ({{date}}).":
    "Reminder: The second review attempt can only be made on or after the deadline ({{date}}).",
  "Reminder: The third review attempt can only be made on the last day of the cure period ({{date}}).":
    "Reminder: The third review attempt can only be made on the last day of the cure period ({{date}}).",
  "Pending Review": "Pending Review",
  "Review started. This may take a while. You can check status below.":
    "Review started. This may take a while. You can check status below.",
  "{{followers}} did not follow {{target}}":
    "{{followers}} did not follow {{target}}",
  "Validation Failed": "Validation Failed",
  "Missing sponsorTaskCompletionId in request body.":
    "Missing sponsorTaskCompletionId in request body.",
  "A server error occurred. Please try again later.":
    "A server error occurred. Please try again later.",
  "Invalid Input": "Invalid Input",
  "The followers array is missing or invalid in the request.":
    "The followers array is missing or invalid in the request.",
  "Configuration Error": "Configuration Error",
  "Instagram credentials are missing in the environment. Please contact support.":
    "Instagram credentials are missing in the environment. Please contact support.",
  "Failed to review task. Please try again later.":
    "Failed to review task. Please try again later.",
  "Failed to review ensure_followers task. {{error}}":
    "Failed to review ensure_followers task. {{error}}",
  "Usernames saved and review started!": "Usernames saved and review started!",
  "Missing sponsorTaskCompletionId or registered_usernames. Please check your input.":
    "Missing sponsorTaskCompletionId or registered_usernames. Please check your input.",
  "Failed to review register_app task: {{error}} (code: {{code}})":
    "Failed to review register_app task: {{error}} (code: {{code}})",
  "Failed to review register_app task: Unknown error":
    "Failed to review register_app task: Unknown error",
  "Failed to review register_app task.": "Failed to review register_app task.",
  "Please grant media library access to upload files.":
    "Please grant media library access to upload files.",
  "Failed to open gallery.": "Failed to open gallery.",
  "Failed to upload proof.": "Failed to upload proof.",
  "Your submission window has closed. You must submit at least one proof before the deadline to qualify for the cure period.":
    "Your submission window has closed. You must submit at least one proof before the deadline to qualify for the cure period.",
  "Sponsor Tasks Review": "Sponsor Tasks Review",
  "Basic Info": "Basic Info",
  "Official IG: {{value}}": "Official IG: {{value}}",
  "Committee IGs: {{value}}": "Committee IGs: {{value}}",
  "Students can upload proof or review their task from 1 week before the deadline until the deadline.\nIf a student submits at least one proof before the deadline, they will have an extra 7-day cure period after the deadline to upload or review.":
    "Students can upload proof or review their task from 1 week before the deadline until the deadline.\nIf a student submits at least one proof before the deadline, they will have an extra 7-day cure period after the deadline to upload or review.",
  "Students can upload proof or review their task from the activity start until the deadline.\nIf a student submits at least one proof before the deadline, they will have an extra 7-day cure period after the deadline to upload or review.":
    "Students can upload proof or review their task from the activity start until the deadline.\nIf a student submits at least one proof before the deadline, they will have an extra 7-day cure period after the deadline to upload or review.",
  "Note: If a student did not upload any proof before or on the deadline ({{date}}), there is NO cure period after the deadline.":
    "Note: If a student did not upload any proof before or on the deadline ({{date}}), there is NO cure period after the deadline.",
  "A student must submit at least one proof before the deadline to be eligible for the 7-day cure period after the deadline.":
    "A student must submit at least one proof before the deadline to be eligible for the 7-day cure period after the deadline.",
  "Cure Period: {{start}} to {{end}} (7 days after deadline)\n\nA student may upload or review their task only if they submitted proof before the deadline.":
    "Cure Period: {{start}} to {{end}} (7 days after deadline)\n\nA student may upload or review their task only if they submitted proof before the deadline.",
  "❌ Task failed": "❌ Task failed",
  "❌ Task failed (max review attempts)": "❌ Task failed (max review attempts)",
  "❌ Task failed (cure period over)": "❌ Task failed (cure period over)",
  "Awaiting business review": "Awaiting business review",
  "❌ Task rejected": "❌ Task rejected",
  "Task Approved": "Task Approved",
  "You have approved this task.": "You have approved this task.",
  "Failed to approve the task.": "Failed to approve the task.",
  "Task Rejected": "Task Rejected",
  "You have rejected this task.": "You have rejected this task.",
  "Failed to reject the task.": "Failed to reject the task.",
  "This task will be automatically checked by our AI bot. No manual approval is needed.":
    "This task will be automatically checked by our AI bot. No manual approval is needed.",
  Approve: "Approve",
  Reject: "Reject",
  "Are you sure you want to approve this task?":
    "Are you sure you want to approve this task?",
  "Review count: {{count}}": "Review count: {{count}}",
  "Student did not upload proof on time. This task is automatically marked as failed.":
    "Student did not upload proof on time. This task is automatically marked as failed.",
  "Waiting for student to upload new proof during cure period.":
    "Waiting for student to upload new proof during cure period.",
  "Student did not upload proof during the cure period. This task is automatically marked as failed.":
    "Student did not upload proof during the cure period. This task is automatically marked as failed.",
  "Failed to load sponsor completions.": "Failed to load sponsor completions.",
  "Task Completions": "Task Completions",
  "✅ All Sponsor Tasks Completed ({{completed}}/{{total}})":
    "✅ All Sponsor Tasks Completed ({{completed}}/{{total}})",
  "Sponsor Tasks: {{completed}}/{{total}} Completed":
    "Sponsor Tasks: {{completed}}/{{total}} Completed",
  "⏰ Deadline: {{date}}": "⏰ Deadline: {{date}}",
  "Activity: {{name}}": "Activity: {{name}}",
  "Redeemed By {{name}}": "Redeemed By {{name}}",
  "No Sponsor Name": "No Sponsor Name",
  Sponsor: "Sponsor",
  "Redeeming...": "Redeeming...",
  "Reject Task": "Reject Task",
  "Reject Document": "Reject Document",
  "Reject Membership Request": "Reject Membership Request",
  "Please provide a reason for rejection:":
    "Please provide a reason for rejection:",
  "Enter reason...": "Enter reason...",
  Submit: "Submit",
  "Enter your username(s) for registration:":
    "Enter your username(s) for registration:",
  Save: "Save",
  "Please fill in all {{count}} username(s).":
    "Please fill in all {{count}} username(s).",
  "Duplicate usernames found. Please ensure all usernames are unique.":
    "Duplicate usernames found. Please ensure all usernames are unique.",
  "Registered account username {{index}}":
    "Registered account username {{index}}",
  "Please fill in all {{count}} Instagram accounts (each must start with @ and not be empty).":
    "Please fill in all {{count}} Instagram accounts (each must start with @ and not be empty).",
  "Duplicate Instagram accounts found. Please ensure all accounts are unique.":
    "Duplicate Instagram accounts found. Please ensure all accounts are unique.",
  "Enter {{count}} Instagram accounts (one per line):":
    "Enter {{count}} Instagram accounts (one per line):",
  "Verify Documents": "Verify Documents",
  HKID: "HKID",
  "No Image": "No Image",
  "HKID Number": "HKID Number",
  "HKID Name": "HKID Name",
  "Student Card": "Student Card",
  "Card Number": "Card Number",
  "Card Name": "Card Name",
  Close: "Close",
  "Sign above": "Sign above",
  "Signed": "Signed",
  "Not signed yet": "Not signed yet",
  Clear: "Clear",
  Confirm: "Confirm",
  "Failed to generate PDF.": "Failed to generate PDF.",
  "Failed to upload PDF to Cloudinary.": "Failed to upload PDF to Cloudinary.",
  "Failed to upload PDF to Cloudinary (no URL returned).":
    "Failed to upload PDF to Cloudinary (no URL returned).",
  "[pdf download url missing] no URL returned":
    "[pdf download url missing] no URL returned",
  Finalize: "Finalize",
  "Finalizing the agreement...": "Finalizing the agreement...",
  "Sign Now": "Sign Now",
  "No events yet": "No events yet",
  "Pull to refresh to see the latest events":
    "Pull to refresh to see the latest events",
  "You're all caught up": "You're all caught up",
  "Previous image": "Previous image",
  "Next image": "Next image",
  "Latest Events": "Latest Events",
  "Load more": "Load more",
  Subscribe: "Subscribe",
  Subscribed: "Subscribed",
  Ended: "Ended",
  "Untitled Event": "Untitled Event",
  "All Events": "All Events",
  "My Events": "My Events",
  "Events you subscribed to": "Events you subscribed to",
  "Search events...": "Search events...",
  "Search results for {{keyword}}": "Search results for {{keyword}}",
  "No events found": "No events found",
  Newest: "Newest",
  Soonest: "Soonest",
  Event: "Event",
  "PostType.Event": "Event",
  "PostType.SocietyActivity": "Society Activity",
  "PostType.Result": "Result",
  "PostType.Recruitment": "Recruitment",
  "PostType.Announcement": "Announcement",
  "PostType.Post": "Post",
  "PostType.Other": "Other",
  "Filter by type": "Filter by type",
  "Filter by university": "Filter by university",
  "Filter by society": "Filter by society",
  "Clear filters": "Clear filters",
  "Apply filters": "Apply filters",
  "Clear all": "Clear all",
  "Search events": "Search events",
  "Clear search": "Clear search",
  "Search results for": "Search results for",
  "No events match your search": "No events match your search",
  Organizers: "Organizers",
  "Who can join?": "Who can join?",
  "Everyone can join": "Everyone can join",
  "No description provided.": "No description provided.",
  "When & Where": "When & Where",
  Time: "Time",
  Tags: "Tags",
  "View original post": "View original post",
  "Open link": "Open link",
  WhatsApp: "WhatsApp",
  "Event not found": "Event not found",
  "This event is no longer available.": "This event is no longer available.",
  "{{count}} events": "{{count}} events",
  "Multi-day": "Multi-day",
  "Subscribed only": "Subscribed only",
  "Multi-day only": "Multi-day only",
  "No events on this day": "No events on this day",
  "Select a day": "Select a day",
  "Tap a highlighted day to see its events.":
    "Tap a highlighted day to see its events.",
  "Previous month": "Previous month",
  "Next month": "Next month",
  "Add to calendar": "Add to calendar",
  "{{count}} more": "+{{count}} more",
  Back: "Back",
  "Please try again later.": "Please try again later.",
  "Pull to refresh to load events.": "Pull to refresh to load events.",
  "User List": "User List",
  "Total Students": "Total Students",
  "Pending Verification": "Pending Verification",
  "Pending Approval": "Pending Approval",
  Businesses: "Businesses",
  Students: "Students",
  Verified: "Verified",
  "Search by name, email, university...":
    "Search by name, email, university...",
  "Search by name, email, BR number...": "Search by name, email, BR number...",
  Filters: "Filters",
  "Verification Status": "Verification Status",
  "No documents": "No documents",
  "Pending review": "Pending review",
  "Student card verified": "Student card verified",
  "HKID verified": "HKID verified",
  "Both documents verified": "Both documents verified",
  "Account Status": "Account Status",
  "Review Status": "Review Status",
  "Clear All": "Clear All",
  Done: "Done",
  "Check Sponsor": "Check Sponsor",
  "Select Sponsor": "Select Sponsor",
  "Select a sponsor redemption to view.":
    "Select a sponsor redemption to view.",
  "No students found": "No students found",
  "No businesses found": "No businesses found",
  "Awaiting admin approval": "Awaiting admin approval",
  "Reject this business?": "Reject this business?",
  "This action cannot be undone": "This action cannot be undone",
  Review: "Review",
  "Submitted": "Submitted",
  "Your business is awaiting admin approval":
    "Your business is awaiting admin approval",
  "Your business registration was rejected":
    "Your business registration was rejected",
  "Your registration has been submitted for admin review. You will be able to log in once it is approved.":
    "Your registration has been submitted for admin review. You will be able to log in once it is approved.",
  "No users match your search": "No users match your search",
  "Try adjusting your search or filters":
    "Try adjusting your search or filters",
  "Something went wrong": "Something went wrong",
  Retry: "Retry",
  Refresh: "Refresh",
  "Pull to refresh to load students.": "Pull to refresh to load students.",
  "Pull to refresh to load businesses.": "Pull to refresh to load businesses.",
  Memberships: "Memberships",
  Joined: "Joined",
  Requested: "Requested",
  Uploaded: "Uploaded",
  "Not uploaded": "Not uploaded",
  "Approved by member - awaiting admin": "Approved by member - awaiting admin",
  "Awaiting approval": "Awaiting approval",
  "Approve this membership request?": "Approve this membership request?",
  "Reject this membership request?": "Reject this membership request?",
  "Membership requests": "Membership requests",
  "{{count}} membership requests": "{{count}} membership requests",
  Role: "Role",
  Verify: "Verify",
  "Verify Student Card": "Verify Student Card",
  "Verify HKID": "Verify HKID",
  Active: "Active",
  Inactive: "Inactive",
  "View Details": "View Details",
  Agreed: "Agreed",
  "No Agreement": "No Agreement",
  Admin: "Admin",
  "Admin Hub": "Admin Hub",
  "Review Sponsor Tasks": "Review Sponsor Tasks",
  Members: "Members",
  "Pending Requests": "Pending Requests",
  "Quick access to admin tools": "Quick access to admin tools",
  Approved: "Approved",
  Rejected: "Rejected",
  "Why failed": "Why failed",
  Proof: "Proof",
  "View Agreement": "View Agreement",
  "Approve Receipt": "Approve Receipt",
  "Reject Receipt": "Reject Receipt",
  "Approve this compensation receipt?": "Approve this compensation receipt?",
  "Reason...": "Reason...",
  "Sponsor Activities": "Sponsor Activities",
  Societies: "Societies",
  "No societies found.": "No societies found.",
  "No pending membership requests.": "No pending membership requests.",
  "No pending membership requests": "No pending membership requests",
  "No sponsor activities found.": "No sponsor activities found.",
  "No societies to review": "No societies to review",
  "No sponsor activities to review": "No sponsor activities to review",
  "Pull to refresh to load societies.": "Pull to refresh to load societies.",
  "Search societies...": "Search societies...",
  "No societies match your search": "No societies match your search",
  "{{count}} societies": "{{count}} societies",
  "{{count}} society": "{{count}} society",
  "End of results": "End of results",
  "Loading more...": "Loading more...",
  "Pull to refresh to check for new requests.":
    "Pull to refresh to check for new requests.",
  "Pull to refresh to load sponsor activities.":
    "Pull to refresh to load sponsor activities.",
  Filter: "Filter",
  "Pending Memberships": "Pending Memberships",
  Business: "Business",
  Chats: "Chats",
  "Manage Chat": "Manage Chat",
  "Leave this chat?": "Leave this chat?",
  Leave: "Leave",
  "Search chats...": "Search chats...",
  "No chats match your search": "No chats match your search",
  "No chats yet": "No chats yet",
  "Try a different name.": "Try a different name.",
  "Start a chat from your redeemed coupons, sponsors or Settings.":
    "Start a chat from your redeemed coupons, sponsors or Settings.",
  "Type a message...": "Type a message...",
  "No messages yet": "No messages yet",
  "Send a message to start the conversation.":
    "Send a message to start the conversation.",
  Today: "Today",
  Yesterday: "Yesterday",
  "You:": "You:",
  Send: "Send",
  "Reconnecting...": "Reconnecting...",
  "Chat with Admin": "Chat with Admin",
  Online: "Online",
  Offline: "Offline",
  "Last seen just now": "Last seen just now",
  "Last seen today at {{time}}": "Last seen today at {{time}}",
  "Last seen yesterday at {{time}}": "Last seen yesterday at {{time}}",
  "Last seen {{date}} at {{time}}": "Last seen {{date}} at {{time}}",
  Read: "Read",
  Group: "Group",
  Dashboard: "Dashboard",
  "User Management": "User Management",
  "Admin Console": "Admin Console",
  Welcome: "Welcome",
  "Page not found": "Page not found",
  "Go to Login": "Go to Login",
  "The student and business web portal is coming soon.":
    "The student and business web portal is coming soon.",
  "Recent Societies": "Recent Societies",
  "Activity not found.": "Activity not found.",
  "Failed to load activity details.": "Failed to load activity details.",
  "No userId or activityId provided.": "No userId or activityId provided.",
  "Log In": "Log In",
  "Join as Student": "Join as Student",
  "Join as Business": "Join as Business",
  "Business Sign In": "Business Sign In",
  "Sign in to your account": "Sign in to your account",
  "New to Uninfo HK?": "New to Uninfo HK?",
  Home: "Home",
  Features: "Features",
  Universities: "Universities",
  About: "About",
  Contact: "Contact",
  Explore: "Explore",
  "All rights reserved.": "All rights reserved.",
  "The all-in-one campus life platform for Hong Kong university students.":
    "The all-in-one campus life platform for Hong Kong university students.",
  "Hong Kong's campus life platform": "Hong Kong's campus life platform",
  "Your university life,": "Your university life,",
  "all in one place.": "all in one place.",
  "Discover events, join societies, complete surveys and redeem coupons — built for Hong Kong university students.":
    "Discover events, join societies, complete surveys and redeem coupons — built for Hong Kong university students.",
  "Discover events, join societies, chat with organizers and redeem coupons — built for Hong Kong university students.":
    "Discover events, join societies, chat with organizers and redeem coupons — built for Hong Kong university students.",
  "For students": "For students",
  "For Students": "For Students",
  "Upcoming Events": "Upcoming Events",
  "This week": "This week",
  "Everything your campus life needs": "Everything your campus life needs",
  "Events & Calendar": "Events & Calendar",
  "Discover campus events, save them to your calendar and never miss out.":
    "Discover campus events, save them to your calendar and never miss out.",
  Surveys: "Surveys",
  "Chat with societies": "Chat with societies",
  "Message organizers and societies in real time and stay in the loop.":
    "Message organizers and societies in real time and stay in the loop.",
  "Activities & QR Check-in": "Activities & QR Check-in",
  "Society Activities": "Society Activities",
  "Join activities hosted by campus societies across Hong Kong.":
    "Join activities hosted by campus societies across Hong Kong.",
  "Business Activities": "Business Activities",
  "Join workshops and activities hosted by partner businesses.":
    "Join workshops and activities hosted by partner businesses.",
  "Check in instantly with a real-time QR code at every activity.":
    "Check in instantly with a real-time QR code at every activity.",
  "Coupons & Redeem": "Coupons & Redeem",
  "Earn points and redeem them for coupons at partner shops.":
    "Earn points and redeem them for coupons at partner shops.",
  "Earn points from surveys and activities, then redeem them for coupons from partner businesses across Hong Kong.":
    "Earn points from surveys and activities, then redeem them for coupons from partner businesses across Hong Kong.",
  "Follow societies and get campus updates":
    "Follow societies and get campus updates",
  "Join activities to earn 20 points": "Join activities to earn 20 points",
  "Redeem coupons from partner shops": "Redeem coupons from partner shops",
  Points: "Points",
  Partners: "Partners",
  "Societies we sponsor and partner with":
    "Societies we sponsor and partner with",
  "Uninfo HK partners with campus societies to bring their events, updates and everything happening on your campus to you.":
    "Uninfo HK partners with campus societies to bring their events, updates and everything happening on your campus to you.",
  members: "members",
  "…and many more societies are partnering with us":
    "…and many more societies are partnering with us",
  "How It Works": "How It Works",
  "Get started in four simple steps": "Get started in four simple steps",
  "Create account": "Create account",
  "Sign up with your verified university email in under a minute.":
    "Sign up with your verified university email in under a minute.",
  "Browse events": "Browse events",
  "Explore events, coupons and societies across Hong Kong.":
    "Explore events, coupons and societies across Hong Kong.",
  "Join & subscribe": "Join & subscribe",
  "Follow societies and subscribe to the events you care about.":
    "Follow societies and subscribe to the events you care about.",
  "Check-in & explore": "Check-in & explore",
  "Check in with your QR code and explore everything your campus offers.":
    "Check in with your QR code and explore everything your campus offers.",
  "Why Choose Us": "Why Choose Us",
  "Built for Hong Kong students": "Built for Hong Kong students",
  "Verified university email": "Verified university email",
  "Easy join": "Easy join",
  "Free access": "Free access",
  "Realtime QR check-in": "Realtime QR check-in",
  "Multi-university": "Multi-university",
  Flexible: "Flexible",
  "Serving all major Hong Kong universities":
    "Serving all major Hong Kong universities",
  "Are you a business or society?": "Are you a business or society?",
  "Reach students and societies across the university community in Hong Kong.":
    "Reach students and societies across the university community in Hong Kong.",
  "Reach thousands of verified university students across Hong Kong.":
    "Reach thousands of verified university students across Hong Kong.",
  Testimonials: "Testimonials",
  "Loved by students": "Loved by students",
  "Business portal coming soon": "Business portal coming soon",
  "We are onboarding partner businesses now. Please contact us to get early access.":
    "We are onboarding partner businesses now. Please contact us to get early access.",
  "Contact Us": "Contact Us",
  Follow: "Follow",
  "Partner Businesses & Coupons": "Partner Businesses & Coupons",
  "Partner businesses": "Partner businesses",
  "Partner businesses across Hong Kong back their offers through Uninfo coupons — and sponsors fund even more.":
    "Partner businesses across Hong Kong back their offers through Uninfo coupons — and sponsors fund even more.",
  "Redeem points for coupons you will love":
    "Redeem points for coupons you will love",
  "Earn points and redeem them at partner shops across Hong Kong — dining, entertainment, shopping, beauty, fashion and fitness.":
    "Earn points and redeem them at partner shops across Hong Kong — dining, entertainment, shopping, beauty, fashion and fitness.",
  Eat: "Eat",
  Play: "Play",
  Buy: "Buy",
  Beauty: "Beauty",
  Fashion: "Fashion",
  Fitness: "Fitness",
  "Coupon types": "Coupon types",
  Travel: "Travel",
  Wellness: "Wellness",
  Education: "Education",
  Pets: "Pets",
  Coffee: "Coffee",
  Gifts: "Gifts",
  "Redeem coupons": "Redeem coupons",
  "Available in the Uninfo app": "Available in the Uninfo app",
  "Get the App": "Get the App",
  "Download on the App Store": "Download on the App Store",
  "Get it on Google Play": "Get it on Google Play",
  "Sponsor Programme": "Sponsor Programme",
  "Sponsored by Uninfo HK": "Sponsored by Uninfo HK",
  "Uninfo HK funds and hosts sponsorships for societies and events across Hong Kong.":
    "Uninfo HK funds and hosts sponsorships for societies and events across Hong Kong.",
  "University Sponsor Fund": "University Sponsor Fund",
  "For Business": "For Business",
  "Universities we partner with": "Universities we partner with",
  "Trusted by societies across HK": "Trusted by societies across HK",
  "Join our partner network to put your brand in front of thousands of verified students.":
    "Join our partner network to put your brand in front of thousands of verified students.",
  "About Uninfo HK": "About Uninfo HK",
  "Uninfo HK is a campus life platform connecting Hong Kong university students with events, societies, surveys and partner businesses — all in one place.":
    "Uninfo HK is a campus life platform connecting Hong Kong university students with events, societies, surveys and partner businesses — all in one place.",
  "Our mission": "Our mission",
  "University life is full of opportunities — but they are scattered across apps, posters and word of mouth. Our mission is to bring every event, society and offer onto one simple platform, so students can spend less time searching and more time doing.":
    "University life is full of opportunities — but they are scattered across apps, posters and word of mouth. Our mission is to bring every event, society and offer onto one simple platform, so students can spend less time searching and more time doing.",
  "Today we serve students across all major Hong Kong universities, and we are just getting started.":
    "Today we serve students across all major Hong Kong universities, and we are just getting started.",
  "What we value": "What we value",
  "Community first": "Community first",
  "We bring societies, students and businesses together on one trusted platform.":
    "We bring societies, students and businesses together on one trusted platform.",
  "Verified & safe": "Verified & safe",
  "Every student account is tied to a verified university email.":
    "Every student account is tied to a verified university email.",
  "Made for students": "Made for students",
  "Free to use, built around the way Hong Kong students actually live.":
    "Free to use, built around the way Hong Kong students actually live.",
  "Ready to explore?": "Ready to explore?",
  "Everything you need to make the most of your university life.":
    "Everything you need to make the most of your university life.",
  "Browse events from every society, save them to your calendar and get reminded before they start.":
    "Browse events from every society, save them to your calendar and get reminded before they start.",
  "Search and filter events by university, society and date":
    "Search and filter events by university, society and date",
  "Save events to your personal calendar":
    "Save events to your personal calendar",
  "Apply to join events with one tap": "Apply to join events with one tap",
  "Complete surveys from societies and universities to earn points and shape campus life.":
    "Complete surveys from societies and universities to earn points and shape campus life.",
  "Answer surveys and earn 10 points each":
    "Answer surveys and earn 10 points each",
  "See survey results and statistics": "See survey results and statistics",
  "Create your own surveys as a society":
    "Create your own surveys as a society",
  "Join activities and check in instantly with a real-time QR code — no queues, no paper.":
    "Join activities and check in instantly with a real-time QR code — no queues, no paper.",
  "Real-time QR check-in at events": "Real-time QR check-in at events",
  "Instant attendance confirmation": "Instant attendance confirmation",
  "Earn 20 points per activity joined": "Earn 20 points per activity joined",
  "Turn your points into real value with coupons from partner businesses across Hong Kong.":
    "Turn your points into real value with coupons from partner businesses across Hong Kong.",
  "Redeem coupons with your earned points":
    "Redeem coupons with your earned points",
  "Discover offers from partner shops": "Discover offers from partner shops",
  "Use coupons with a simple scan": "Use coupons with a simple scan",
  "Follow societies, join their memberships and never miss what they are up to.":
    "Follow societies, join their memberships and never miss what they are up to.",
  "Follow and subscribe to societies": "Follow and subscribe to societies",
  "Join society memberships": "Join society memberships",
  "Get updates on society events": "Get updates on society events",
  "Ready to get started?": "Ready to get started?",
  "Uninfo HK serves students across all major Hong Kong universities.":
    "Uninfo HK serves students across all major Hong Kong universities.",
  "Your university not listed?": "Your university not listed?",
  "We are expanding all the time. Contact us to bring Uninfo to your campus.":
    "We are expanding all the time. Contact us to bring Uninfo to your campus.",
  "Questions, feedback or partnership ideas? We would love to hear from you.":
    "Questions, feedback or partnership ideas? We would love to hear from you.",
  "Get in touch": "Get in touch",
  Social: "Social",
  "Send us a message": "Send us a message",
  Name: "Name",
  "Your name": "Your name",
  Message: "Message",
  "How can we help?": "How can we help?",
  "Send Message": "Send Message",
  "Message sent": "Message sent",
  "Thank you for reaching out. We will get back to you soon.":
    "Thank you for reaching out. We will get back to you soon.",
  "Create your account with your university email.":
    "Create your account with your university email.",
  "Create your account with your company email.":
    "Create your account with your company email.",
  Profile: "Profile",
  "Change photo": "Change photo",
  "Could not cache this photo. It will still be uploaded when you register.":
    "Could not cache this photo. It will still be uploaded when you register.",
  Male: "Male",
  Female: "Female",
  Others: "Others",
  "Welcome to Uninfo HK. Your account is ready!":
    "Welcome to Uninfo HK. Your account is ready!",
  "Your campus life, all in one place.": "Your campus life, all in one place.",
  Events: "Events",
  "Browse campus events": "Browse campus events",
  "QR Check-in": "QR Check-in",
  "Check in at activities": "Check in at activities",
  Coupons: "Coupons",
  "Redeem your points": "Redeem your points",
  "Follow your societies": "Follow your societies",
  "The full student experience is coming soon.":
    "The full student experience is coming soon.",
  "Events, coupons and more are on the way.":
    "Events, coupons and more are on the way.",
  "My Societies": "My Societies",
  "No societies yet": "No societies yet",
  "Societies you join will appear here.":
    "Societies you join will appear here.",
  "Societies you follow will appear here.":
    "Societies you follow will appear here.",
  Unfollow: "Unfollow",
  Unsubscribe: "Unsubscribe",
  "Events you subscribe to will appear here.":
    "Events you subscribe to will appear here.",
  "No notifications yet": "No notifications yet",
  "Notifications from societies and Uninfo HK will appear here.":
    "Notifications from societies and Uninfo HK will appear here.",
  "Profile updated successfully!": "Profile updated successfully!",
  "Password changed successfully!": "Password changed successfully!",
  "You'll be signed out of your account.":
    "You'll be signed out of your account.",
  Notifications: "Notifications",
  Messages: "Messages",
  "Coming soon": "Coming soon",
  "Business Portal": "Business Portal",
  "Back to Home": "Back to Home",
  "Welcome back": "Welcome back",
  "Sign in to access your account": "Sign in to access your account",
  Student: "Student",
  Terms: "Terms",
  Privacy: "Privacy",
  "← Back to home": "← Back to home",
  "Terms of Service": "Terms of Service",
  "Privacy Policy": "Privacy Policy",
  "Please read these terms carefully before using the Uninfo HK platform.":
    "Please read these terms carefully before using the Uninfo HK platform.",
  "By creating an account or using our services, you agree to these terms.":
    "By creating an account or using our services, you agree to these terms.",
  "We collect the information you provide when creating an account, such as your university email and profile details.":
    "We collect the information you provide when creating an account, such as your university email and profile details.",
  "We use your data to provide, maintain and improve our services.":
    "We use your data to provide, maintain and improve our services.",
  "Scan QR to redeem": "Scan QR to redeem",
  "Only students can redeem coupons": "Only students can redeem coupons",
  "Refresh to see the latest offers": "Refresh to see the latest offers",
  "Refresh to see the latest sponsors": "Refresh to see the latest sponsors",
  "Show QR code": "Show QR code",
  "Show this QR code to the shop staff": "Show this QR code to the shop staff",
  "Terms & Conditions": "Terms & Conditions",
  "Tap to view terms": "Tap to view terms",
  "Points to redeem": "Points to redeem",
  HKD: "HKD",
  "Valid until": "Valid until",
  "Promo Code": "Promo Code",
  "Redeemed Coupon Expired": "Redeemed Coupon Expired",
  "Scan again": "Scan again",
  "Starting camera...": "Starting camera...",
  "Camera permission denied. Please enable it in your browser settings.":
    "Camera permission denied. Please enable it in your browser settings.",
  "No camera found on this device.": "No camera found on this device.",
  "The camera is being used by another application.":
    "The camera is being used by another application.",
  "Camera access requires a secure (HTTPS) connection.":
    "Camera access requires a secure (HTTPS) connection.",
  "Unable to start the camera. Please try again.":
    "Unable to start the camera. Please try again.",
  "Create Event": "Create Event",
  "Create Event Successfully!": "Create Event Successfully!",
  "Edit Event Successfully!": "Edit Event Successfully!",
  "My Created Events": "My Created Events",
  "Events uploaded by your societies": "Events uploaded by your societies",
  "Events you upload will appear here.": "Events you upload will appear here.",
  "Join a society to create an event": "Join a society to create an event",
  "Step {{current}} of {{total}}": "Step {{current}} of {{total}}",
  Next: "Next",
  "The first image is used as the cover of your event.":
    "The first image is used as the cover of your event.",
  Cover: "Cover",
  "Add Image": "Add Image",
  "Hash tags cannot be changed after the event is created.":
    "Hash tags cannot be changed after the event is created.",
  "Add a tag": "Add a tag",
  "End date cannot be earlier than the start date":
    "End date cannot be earlier than the start date",
  "All Day": "All Day",
  "Allow all users to join this event": "Allow all users to join this event",
  "Select your Bachelor degree": "Select your Bachelor degree",
  "Search bachelor degrees...": "Search bachelor degrees...",
  Selected: "Selected",
  "No result found": "No result found",
  "Create Coupon": "Create Coupon",
  "Can`t Create Coupon": "Can`t Create Coupon",
  "Enable QR Redemption": "Enable QR redemption",
  "Show QR": "Show QR",
  Scan: "Scan",
  "Delete Coupon": "Delete Coupon",
  "Delete Coupon Confirm":
    "Are you sure you want to delete this coupon? Students who already redeemed it can still use it before the expiry date.",
  "Coupon Deleted": "Coupon deleted.",
  "Customer scans to redeem": "Customer scans to redeem",
  Sponsors: "Sponsors",
  Change: "Change",
  "Previous Month": "Previous Month",
  "Next Month": "Next Month",
  "No sponsor tasks found.": "No sponsor tasks found.",
  Used: "Used",
  "Reach & Engagement": "Reach & Engagement",
  "Coupon Reads": "Coupon Reads",
  "Coupon Redeemed": "Coupon Redeemed",
  "Sponsor Reads": "Sponsor Reads",
  "Sponsor Redeemed": "Sponsor Redeemed",
  Reads: "Reads",
  Readers: "Readers",
  View: "View",
  "Company Name": "Company Name",
  "Company Email": "Company Email",
  "Contact Number": "Contact Number",
  "Company Address": "Company Address",
  "BR Number": "BR Number",
  "BR Document": "BR Document",
  "Member Since": "Member Since",
  "Billing & Plan": "Billing & Plan",
  "Current Plan": "Current Plan",
  Monthly: "Monthly",
  Yearly: "Yearly",
  month: "month",
  year: "year",
  "No active plan": "No active plan",
  "Free until {{date}}": "Free until {{date}}",
  "Renews on {{date}}": "Renews on {{date}}",
  "Choose Plan": "Choose Plan",
  "Manage Billing": "Manage Billing",
  "Outstanding balance": "Outstanding balance",
  "Nothing outstanding": "Nothing outstanding",
  "Card on file": "Card on file",
  "Late fee": "Late fee",
  Shortfall: "Shortfall",
  Expiry: "Expiry",
  "Expiry month": "Expiry month",
  "Expiry year": "Expiry year",
  "Card number": "Card number",
  "Security code (CVC)": "Security code (CVC)",
  "Cardholder name (optional)": "Cardholder name (optional)",
  "See the Dashboard for the month-by-month statement.":
    "See the Dashboard for the month-by-month statement.",
  "Cancel Subscription": "Cancel Subscription",
  "Re-enable auto-renewal": "Re-enable auto-renewal",
  "Change Plan at Next Renewal": "Change Plan at Next Renewal",
  "Subscription ends on {{date}}": "Subscription ends on {{date}}",
  "from next renewal": "from next renewal",
  "First 100 businesses: first year free":
    "First 100 businesses: first year free",
  "Your plan stays active until {{date}}. Continue?":
    "Your plan stays active until {{date}}. Continue?",
  "the end of the current period": "the end of the current period",
  "Minimum term ends {{date}}": "Minimum term ends {{date}}",
  "Auto-renewal cancelled — plan ends on {{date}}":
    "Auto-renewal cancelled — plan ends on {{date}}",
  "Cancelling will stop your plan at the end of your 12-month minimum term ({{date}}). Continue?":
    "Cancelling will stop your plan at the end of your 12-month minimum term ({{date}}). Continue?",
  "A 12-month minimum term applies to the Yearly plan.":
    "A 12-month minimum term applies to the Yearly plan.",
  "Payment overdue": "Payment overdue",
  "Please pay by {{date}} to avoid a late fee of HKD {{amount}} per day.":
    "Please pay by {{date}} to avoid a late fee of HKD {{amount}} per day.",
  "Late fee accrued: HKD {{amount}}": "Late fee accrued: HKD {{amount}}",
  "Pay now": "Pay now",
  "Your subscription has ended. Please renew to continue.":
    "Your subscription has ended. Please renew to continue.",
  "Your subscription has ended. Paid features are disabled until the account is reactivated.":
    "Your subscription has ended. Paid features are disabled until the account is reactivated.",
  "Contact support to reactivate your account.":
    "Contact support to reactivate your account.",
  "A late fee of HKD {{amount}} has accrued over {{days}} day(s).":
    "A late fee of HKD {{amount}} has accrued over {{days}} day(s).",
  "Update your card or pay the outstanding amount to avoid losing access.":
    "Update your card or pay the outstanding amount to avoid losing access.",
  "Your card on file is no longer valid.":
    "Your card on file is no longer valid.",
  "Use the Update card button below to update your payment method.":
    "Use the Update card button below to update your payment method.",
  "Your last payment failed.": "Your last payment failed.",
  "Update your card to complete the payment.":
    "Update your card to complete the payment.",
  "Auto-renewal is off. Your plan stays active until {{date}}.":
    "Auto-renewal is off. Your plan stays active until {{date}}.",
  "First 100: your first year is free until {{date}}.":
    "First 100: your first year is free until {{date}}.",
  "Choose a plan to activate your account.":
    "Choose a plan to activate your account.",
  "Free plan (First 100)": "Free plan (First 100)",
  "Start a chat from a student reviewing your coupon or sponsor task.":
    "Start a chat from a student reviewing your coupon or sponsor task.",
  "All Tasks": "All Tasks",
  "No tasks": "No tasks",
  "Redeem now": "Redeem now",
  Redeemed: "Redeemed",
  "My Redemptions": "My Redemptions",
  Menu: "Menu",
  "My redeemed coupons": "My redeemed coupons",
  "No redeemed coupons": "No redeemed coupons",
  "Redeem a coupon to see it here": "Redeem a coupon to see it here",
  "My redeemed sponsors": "My redeemed sponsors",
  "No redeemed sponsors": "No redeemed sponsors",
  "Redeem a sponsor to see it here": "Redeem a sponsor to see it here",
  "This sponsor has no tasks yet.": "This sponsor has no tasks yet.",
  "Sponsor activity not found": "Sponsor activity not found",
  "Please go back and try again.": "Please go back and try again.",
  "Room name": "Room name",
  Subtitle: "Subtitle",
  "Redeem successful!": "Redeem successful!",
  "Redeem failed. Please try again.": "Redeem failed. Please try again.",
  "You can only redeem this sponsor once.":
    "You can only redeem this sponsor once.",
  "Your Proof Code": "Your Proof Code",
  "The proof code must be clearly visible in your Instagram Story/Post. Do not reuse the same Story/Post for another sponsor.":
    "The proof code must be clearly visible in your Instagram Story/Post. Do not reuse the same Story/Post for another sponsor.",
  "Instagram Post URL": "Instagram Post URL",
  "Instagram Post URL Required": "Instagram Post URL Required",
  "Enter the Instagram post URL that shows this redemption's proof code before uploading your screenshots.":
    "Enter the Instagram post URL that shows this redemption's proof code before uploading your screenshots.",
  "Proof Already Used": "Proof Already Used",
  "These follower accounts were already used for another sponsor task: {{conflicts}}. Remove them and submit different accounts.":
    "These follower accounts were already used for another sponsor task: {{conflicts}}. Remove them and submit different accounts.",
  "This proof has already been used for another sponsor task.":
    "This proof has already been used for another sponsor task.",
  "Only {{count}} of 4 required sponsor tasks are available.":
    "Only {{count}} of 4 required sponsor tasks are available.",
  "Select at least 4 sponsor tasks.": "Select at least 4 sponsor tasks.",
  "Only {{count}} of 4 required sponsor tasks are available. Follow & Like Post is unavailable because {{handles}} were already used for {{sponsor}}. Please use different committee accounts.":
    "Only {{count}} of 4 required sponsor tasks are available. Follow & Like Post is unavailable because {{handles}} were already used for {{sponsor}}. Please use different committee accounts.",
  "Unavailable: {{handles}} already used for {{sponsor}}.":
    "Unavailable: {{handles}} already used for {{sponsor}}.",
  "Unavailable for this redemption.": "Unavailable for this redemption.",
  "At least 4 available sponsor tasks are required.":
    "At least 4 available sponsor tasks are required.",
  "This proof was already used for another sponsor task: {{conflicts}}. Upload a different post or media.":
    "This proof was already used for another sponsor task: {{conflicts}}. Upload a different post or media.",
  "Checking...": "Checking...",
  "Proof Code": "Proof Code",
  "Reject if the proof code is not clearly visible in the Story/Post.":
    "Reject if the proof code is not clearly visible in the Story/Post.",
  "Society membership not verified yet. Please wait for a society member to approve.":
    "Society membership not verified yet. Please wait for a society member to approve.",
  "Can't get sponsor tasks. Please contact support.":
    "Can't get sponsor tasks. Please contact support.",
  "Sponsor redemption limit reached. Please try another sponsor.":
    "Sponsor redemption limit reached. Please try another sponsor.",
  "Sponsor not found or has been removed.":
    "Sponsor not found or has been removed.",
  "Redeem as: {{societyName}}": "Redeem as: {{societyName}}",
  "Fill in activity details": "Fill in activity details",
  "Activity name for sponsor": "Activity name for sponsor",
  "Activity date (e.g. 2026-04-01)": "Activity date (e.g. 2026-04-01)",
  "Please fill in both activity name and date.":
    "Please fill in both activity name and date.",
  "Please select a future date (tomorrow or later).":
    "Please select a future date (tomorrow or later).",
  "Please fill in the official society Instagram account.":
    "Please fill in the official society Instagram account.",
  "Please fill in at least five committee IG accounts.":
    "Please fill in at least five committee IG accounts.",
  "Duplicate Instagram accounts found between committee and official. Please ensure all are unique.":
    "Duplicate Instagram accounts found between committee and official. Please ensure all are unique.",
  "Official society Instagram account": "Official society Instagram account",
  "Committee IG Accounts (at least 5)": "Committee IG Accounts (at least 5)",
  "Add Committee Account": "Add Committee Account",
  "Committee IG accounts are only required when redeeming as a society.":
    "Committee IG accounts are only required when redeeming as a society.",
  "Student Sponsorship Agreement": "Student Sponsorship Agreement",
  "I have read and accept the agreement above":
    "I have read and accept the agreement above",
  "By signing, you agree to the sponsor terms and conditions.":
    "By signing, you agree to the sponsor terms and conditions.",
  "Select your society": "Select your society",
  "All Societies": "All Societies",
  "Add new society": "Add new society",
  "Register new society": "Register new society",
  "Confirm Society": "Confirm Society",
  "Send membership request to this society? A society member will review and approve.":
    "Send membership request to this society? A society member will review and approve.",
  "Membership request sent. Please wait for a society member to approve before you can redeem as a society.":
    "Membership request sent. Please wait for a society member to approve before you can redeem as a society.",
  "Membership Request Sent": "Membership Request Sent",
  "Your membership request is already under review. Please wait for a society member to approve.":
    "Your membership request is already under review. Please wait for a society member to approve.",
  "You already have a pending membership request. Please wait for approval.":
    "You already have a pending membership request. Please wait for approval.",
  "You have a pending membership request. Join another society after it is approved.":
    "You have a pending membership request. Join another society after it is approved.",
  "Failed to send membership request. Please try again.":
    "Failed to send membership request. Please try again.",
  "Failed to load societies. Please try again.":
    "Failed to load societies. Please try again.",
  "Society name *": "Society name *",
  "Please enter the society name.": "Please enter the society name.",
  "Upload HKID *": "Upload HKID *",
  "Upload Student Card *": "Upload Student Card *",
  "Upload Society Icon (optional)": "Upload Society Icon (optional)",
  "Upload Society Chop (optional)": "Upload Society Chop (optional)",
  "Select university": "Select university",
  "Instagram URL": "Instagram URL",
  "Please upload both HKID and student card.":
    "Please upload both HKID and student card.",
  "Tap to upload HKID": "Tap to upload HKID",
  "Tap to upload student card": "Tap to upload student card",
  "Tap to upload icon": "Tap to upload icon",
  "Tap to upload society chop": "Tap to upload society chop",
  "HKID selected": "HKID selected",
  "Student card selected": "Student card selected",
  "Icon selected": "Icon selected",
  "Chop selected": "Chop selected",
  "Society chop": "Society chop",
  "Student card": "Student card",
  Register: "Register",
  "Society registered!": "Society registered!",
  "Your society registration has been submitted for admin approval. Your membership will be reviewed by an admin. You can redeem as this society once approved.":
    "Your society registration has been submitted for admin approval. Your membership will be reviewed by an admin. You can redeem as this society once approved.",
  "Your society registration has been submitted for admin approval. You may proceed with the redemption.":
    "Your society registration has been submitted for admin approval. You may proceed with the redemption.",
  "Failed to register society. Please try again.":
    "Failed to register society. Please try again.",
  "Upload failed. Please try again.": "Upload failed. Please try again.",
  "Failed to read the selected file.": "Failed to read the selected file.",
  "Upload your documents": "Upload your documents",
  "Upload your HKID and student card to verify your identity before redeeming as an individual.":
    "Upload your HKID and student card to verify your identity before redeeming as an individual.",
  "Please upload both your HKID and student card images.":
    "Please upload both your HKID and student card images.",
  "Personal verification pending. Please wait for UninfoHK to verify your documents.":
    "Personal verification pending. Please wait for UninfoHK to verify your documents.",
  "Chat with Business": "Chat with Business",
  "View Signed Agreement": "View Signed Agreement",
  "The signed agreement could not be displayed.":
    "The signed agreement could not be displayed.",
  "Open the agreement in a new tab": "Open the agreement in a new tab",
  Deadline: "Deadline",
  "In Progress": "In Progress",
  "Sponsor Task Completed": "Sponsor Task Completed",
  "Sponsor Tasks Failed": "Sponsor Tasks Failed",
  "You can upload proof or review your task from the activity start until the deadline. If you submit at least one proof before the deadline, you will have an extra 7-day cure period after the deadline to upload or review.":
    "You can upload proof or review your task from the activity start until the deadline. If you submit at least one proof before the deadline, you will have an extra 7-day cure period after the deadline to upload or review.",
  "Cure Period: {{start}} to {{end}} (7 days after deadline) You may upload or review your task only if you submitted proof before the deadline.":
    "Cure Period: {{start}} to {{end}} (7 days after deadline) You may upload or review your task only if you submitted proof before the deadline.",
  Incomplete: "Incomplete",
  "Show fail reason": "Show fail reason",
  "Upload 2 Images": "Upload 2 Images",
  "Proof uploaded successfully!": "Proof uploaded successfully!",
  "Failed to submit proof.": "Failed to submit proof.",
  "Failed to save usernames.": "Failed to save usernames.",
  "Failed to review task.": "Failed to review task.",
  "You can upload a maximum of 2 images for this task.":
    "You can upload a maximum of 2 images for this task.",
  "Enter the IG usernames of the students who followed the accounts.":
    "Enter the IG usernames of the students who followed the accounts.",
  "Enter the registered username of each committee member.":
    "Enter the registered username of each committee member.",
  "{{count}} file(s) selected": "{{count}} file(s) selected",
  "{{count}} file(s) ready to submit": "{{count}} file(s) ready to submit",
  "You must upload a compensation receipt. The receipt must clearly show: - The name of the recipient - The date of payment - The name of the person paying the compensation":
    "You must upload a compensation receipt. The receipt must clearly show: - The name of the recipient - The date of payment - The name of the person paying the compensation",
  Language: "Language",
  "Grow your brand on campus": "Grow your brand on campus",
  "Reach a real student audience — every account is tied to a verified university email.":
    "Reach a real student audience — every account is tied to a verified university email.",
  "Feature your events and workshops on the calendar students already browse every day.":
    "Feature your events and workshops on the calendar students already browse every day.",
  "Reward students with coupons they redeem with points, and sponsor society events too.":
    "Reward students with coupons they redeem with points, and sponsor society events too.",
  "Run activities with real-time QR check-in and get instant, verified attendance.":
    "Run activities with real-time QR check-in and get instant, verified attendance.",
  "Message interested students in real time and keep the conversation going.":
    "Message interested students in real time and keep the conversation going.",
  "The pros of partnering with us": "The pros of partnering with us",
  "Built-in tools make it easy to get your brand in front of the student community":
    "Built-in tools make it easy to get your brand in front of the student community",
  "Connect with students and societies across Hong Kong's universities":
    "Connect with students and societies across Hong Kong's universities",
  "Create activities students can join": "Create activities students can join",
  "First 100 businesses free for 1 year": "First 100 businesses free for 1 year",
  "Join free for your first year — limited to the first 100 businesses":
    "Join free for your first year — limited to the first 100 businesses",
  "Post events and activities that students can join directly on the platform":
    "Post events and activities that students can join directly on the platform",
  "Promote your brand to students — easily": "Promote your brand to students — easily",
  "Reach the university community": "Reach the university community",
  "Free to join": "Free to join",
  "Join as a partner with no upfront cost.": "Join as a partner with no upfront cost.",
  "What you can do to reach students": "What you can do to reach students",
  "Publish coupons": "Publish coupons",
  "Create redeemable coupons students earn with points.":
    "Create redeemable coupons students earn with points.",
  "Host events & workshops": "Host events & workshops",
  "List your activities on the student calendar.":
    "List your activities on the student calendar.",
  "Sponsor societies": "Sponsor societies",
  "Fund society events to put your brand in front of engaged members.":
    "Fund society events to put your brand in front of engaged members.",
  "What we do to help you reach students & societies":
    "What we do to help you reach students & societies",
  "Connect you with the university community": "Connect you with the university community",
  "Coupons, events and sponsorships get your brand noticed by students":
    "Coupons, events and sponsorships get your brand noticed by students",
  "Promote your brand to the community": "Promote your brand to the community",
  "Put your activities in front of students": "Put your activities in front of students",
  "See activities, redemptions and messages in one partner dashboard":
    "See activities, redemptions and messages in one partner dashboard",
  "Track everything in one dashboard": "Track everything in one dashboard",
  "We bring your brand into a community of students and societies across Hong Kong universities":
    "We bring your brand into a community of students and societies across Hong Kong universities",
  "Your events and activities are listed on the student calendar for easy joining":
    "Your events and activities are listed on the student calendar for easy joining",
  "Society network": "Society network",
  "We connect you with the right societies across universities.":
    "We connect you with the right societies across universities.",
  "Three steps to become a partner": "Three steps to become a partner",
  Apply: "Apply",
  "Tell us about your business and the students you want to reach.":
    "Tell us about your business and the students you want to reach.",
  "Set up your offers": "Set up your offers",
  "Publish coupons, events and activities from your partner dashboard.":
    "Publish coupons, events and activities from your partner dashboard.",
  "Grow your reach": "Grow your reach",
  "Track redemptions, attendance and messages in one partner dashboard.":
    "Track redemptions, attendance and messages in one partner dashboard.",
  "Ready to grow with Uninfo HK?": "Ready to grow with Uninfo HK?",
  "Uninfo HK": "Uninfo HK",
  "Show password": "Show password",
  "Hide password": "Hide password",
  "Student Verification": "Student Verification",
  "Not Verified": "Not Verified",
  "Pending approval": "Pending approval",
  "Upload Student Card": "Upload Student Card",
  "Upload HKID": "Upload HKID",
  "Upload Documents": "Upload Documents",
  "Your identity has been verified.": "Your identity has been verified.",
  "Your documents are being reviewed by an admin.":
    "Your documents are being reviewed by an admin.",
  "Verify your identity to redeem coupons, sponsors and join activities.":
    "Verify your identity to redeem coupons, sponsors and join activities.",
  "Upload your HKID (Optional)": "Upload your HKID (Optional)",
  "Uninfo will verify your HKID in 24 hrs": "Uninfo will verify your HKID in 24 hrs",
  "Upload your HKID to redeem coupons and sponsors.":
    "Upload your HKID to redeem coupons and sponsors.",
  "Upload your student card to join activities and redeem.":
    "Upload your student card to join activities and redeem.",
  "Please upload at least one document.": "Please upload at least one document.",
  "Student has not uploaded HKID": "Student has not uploaded HKID",
  "Student has not uploaded student card": "Student has not uploaded student card",
  "Upload the front of your student card. Once approved, you can join activities and events.":
    "Upload the front of your student card. Once approved, you can join activities and events.",
  "Upload the front of your Hong Kong Identity Card. Needed to redeem coupons and sponsor offers (with an approved student card).":
    "Upload the front of your Hong Kong Identity Card. Needed to redeem coupons and sponsor offers (with an approved student card).",
  "This document is already on file and cannot be replaced.":
    "This document is already on file and cannot be replaced.",
  Product: "Product",
  "Max participants": "Max participants",
  "Not available": "Not available",
  "Please fill in a whole number of participants between 1 and {{max}}.":
    "Please fill in a whole number of participants between 1 and {{max}}.",
  "Missing or invalid participants quantity.":
    "Missing or invalid participants quantity.",
  "Participants quantity is out of range.":
    "Participants quantity is out of range.",
  "Redemption quantity is invalid.": "Redemption quantity is invalid.",
  "Something went wrong on our side. Please try again.":
    "Something went wrong on our side. Please try again.",
  "All categories": "All categories",
  "No sponsors in this category": "No sponsors in this category",
  "Choose quantity": "Choose quantity",
  "Max quantity": "Max quantity",
  "Quantity (packs as priced)": "Quantity (packs as priced)",
  "You can claim up to {{maxQuantity}} for {{participants}} participants.":
    "You can claim up to {{maxQuantity}} for {{participants}} participants.",
  "Could not load the sponsor obligations. Please try again.":
    "Could not load the sponsor obligations. Please try again.",
  "Redemption quantity is invalid": "Redemption quantity is invalid",
  
  "You are not a member of any society yet — join one to redeem as a society.": "You are not a member of any society yet — join one to redeem as a society.",
  Member: "Member",
  Join: "Join",
  "Decrease quantity": "Decrease quantity",
  "Increase quantity": "Increase quantity",
  "Showing {{from}}–{{to}} of {{total}}": "Showing {{from}}–{{to}} of {{total}}",
  "Previous page": "Previous page",
  "Next page": "Next page",
  "Page {{page}} of {{total}}": "Page {{page}} of {{total}}",
  // Admin console login
  "Administration, in one place.": "Administration, in one place.",
  "Review students, societies and sponsors across the Uninfo platform.":
    "Review students, societies and sponsors across the Uninfo platform.",
  "Authorised administrators only.": "Authorised administrators only.",
  "Signing in...": "Signing in...",
  "Admin Not Found or Inactive": "Admin Not Found or Inactive",
  "Admin Invalid Password": "Admin Invalid Password",
  "Admin Account Is Not Active": "Admin Account Is Not Active",
  "Upload society chop": "Upload society chop",
  "Replace society chop": "Replace society chop",
  "A society chop is required to finalize":
    "A society chop is required to finalize",
  "Failed to generate the signed agreement. Please try again.":
    "Failed to generate the signed agreement. Please try again.",
  Accept: "Accept",
  Accepted: "Accepted",
  Activities: "Activities",
  "Activities will appear here.": "Activities will appear here.",
  "Activities you create will appear here.":
    "Activities you create will appear here.",
  "Activities you join will appear here.":
    "Activities you join will appear here.",
  "Browse activities": "Browse activities",
  "Discover activities, join in and manage the ones you create.":
    "Discover activities, join in and manage the ones you create.",
  "Organizer unavailable": "Organizer unavailable",
  "This activity is unavailable because the organizer is not active.":
    "This activity is unavailable because the organizer is not active.",
  "Activity ended": "Activity ended",
  "Applications closed": "Applications closed",
  "Full": "Full",
  "This activity has already taken place.":
    "This activity has already taken place.",
  "The application deadline has passed.":
    "The application deadline has passed.",
  "This activity is full.": "This activity is full.",
  "View details": "View details",
  "Are you sure you want to delete this activity?":
    "Are you sure you want to delete this activity?",
  "Deadline Date": "Deadline Date",
  "Deadline Time": "Deadline Time",
  Details: "Details",
  HashTags: "HashTags",
  "Joining...": "Joining...",
  "Load More": "Load More",
  "Meeting Date": "Meeting Date",
  "Meeting Date & Time": "Meeting Date & Time",
  "Meeting Time": "Meeting Time",
  "No activities yet": "No activities yet",
  Category: "Category",
  "Select a category": "Select a category",
  "ActivityCategory.Sports": "Sports",
  "ActivityCategory.Outdoors": "Outdoors",
  "ActivityCategory.FoodDrink": "Food & Drink",
  "ActivityCategory.Study": "Study",
  "ActivityCategory.Games": "Games",
  "ActivityCategory.BoardGame": "Board Game",
  "ActivityCategory.Social": "Social",
  "ActivityCategory.ArtsCulture": "Arts & Culture",
  "ActivityCategory.Music": "Music",
  "ActivityCategory.Wellness": "Wellness",
  "ActivityCategory.Technology": "Technology",
  "ActivityCategory.Volunteering": "Volunteering",
  "ActivityCategory.Other": "Other",
  "No participants yet": "No participants yet",
  "Pull to refresh to load activities.": "Pull to refresh to load activities.",
  "signup.businessEmailExisted": "Business email already exists",
  "Business Registration No.": "Business Registration No.",
  "Business Registration Certificate": "Business Registration Certificate",
  "Business Details": "Business Details",
  "Create Business Account": "Create Business Account",
  "Please upload your business registration certificate":
    "Please upload your business registration certificate",
  Photo: "Photo",
  Continue: "Continue",
  Plan: "Plan",
  "Choose your plan": "Choose your plan",
  "planDiscount.badge": "~{{percent}}% off",
  "planDiscount.savings": "Save HKD {{amount}}/year · 2 months free",
  "First 100 businesses get their first year free. Eligibility is confirmed after sign-up.":
    "First 100 businesses get their first year free. Eligibility is confirmed after sign-up.",
  "I have read and accept the": "I have read and accept the",
  "Business Terms & Conditions": "Business Terms & Conditions",
  "Please accept the Business Terms & Conditions":
    "Please accept the Business Terms & Conditions",
  "Your registration is approved. Complete your subscription to activate your account.":
    "Your registration is approved. Complete your subscription to activate your account.",
  "businessTerms.lastUpdated": "Last updated: November 2026",
  "businessTerms.intro":
    "These Business Terms & Conditions (\"Terms\") govern your access to and use of the Uninfo HK platform as a business user. By registering a business account, selecting a subscription plan and accepting these Terms, you agree to be bound by them. If you do not agree, do not register for or use the business services.",
  "businessTerms.acceptance.title": "1. Acceptance of Terms",
  "businessTerms.acceptance.p1":
    "By creating a business account, you confirm that you have read, understood and accepted these Terms, together with our general Terms of Service and Privacy Policy.",
  "businessTerms.acceptance.p2":
    "You must accept these Terms at the time of registration. Your acceptance, and the version of the Terms accepted, are recorded by Uninfo HK.",
  "businessTerms.eligibility.title": "2. Eligibility & Business Account",
  "businessTerms.eligibility.p1":
    "You must be a duly registered business in Hong Kong (or otherwise lawfully operating) and must provide accurate, current and complete information, including a valid Business Registration (BR) number and certificate.",
  "businessTerms.eligibility.p2":
    "You represent and warrant that you have the authority to bind the business to these Terms and that all information you submit is true, accurate and not misleading. We may verify your information and may approve, reject, restrict or suspend a business account at our sole discretion, without liability.",
  "businessTerms.fees.title": "3. Subscription Plans & Fees",
  "businessTerms.fees.p1":
    "Uninfo HK offers a Yearly plan at HKD 500 per year (prices in Hong Kong Dollars).",
  "businessTerms.fees.p2":
    "Unless stated otherwise, subscriptions renew automatically at the end of each yearly billing period at the then-current rate for the Yearly plan, until cancelled in accordance with these Terms. Uninfo HK may change its fees or plan prices at any time; changes take effect when posted on the platform or notified to you, and your continued use of the business services after a fee change constitutes your acceptance of the new fees.",
  "businessTerms.payment.title": "4. Payment & Card Authorization",
  "businessTerms.payment.p1":
    "Payments are processed by our third-party payment provider, Stripe. By providing card details you authorise Stripe to charge the applicable subscription fee and any applicable taxes.",
  "businessTerms.payment.p2":
    "Uninfo HK does not store your full card details; card data is handled by Stripe under its own terms. You must keep valid, current payment details on file and you authorise recurring charges at the start of each renewal period until you cancel. You remain responsible for all fees and charges incurred before cancellation takes effect.",
  "businessTerms.coupon.title":
    "5. Minimum Monthly Coupon Requirement, Coupon & Activity Exclusivity",
  "businessTerms.coupon.p1":
    "As a condition of your subscription, you must publish at least one (1) new coupon on the platform in each calendar month during which your business account is active.",
  "businessTerms.coupon.p2":
    "\"Coupon\" means any offer, discount, voucher, deal or promotion you make available for redemption on the platform. A coupon counts as \"new\" only if it has not previously been published on the platform and is not simultaneously offered elsewhere.",
  "businessTerms.coupon.p3":
    "Coupon exclusivity. Each coupon you publish on the platform must be offered exclusively through Uninfo HK. While a coupon is live on the platform (and for any period it is advertised or promoted by Uninfo HK), you must not publish, advertise, list or otherwise make the same coupon — or any substantially similar coupon, offer or discount — available on any other platform, marketplace, website, application, social media channel or physical outlet, whether at the same or a different price. You must not publish, re-publish, recycle or reframe a previously offered coupon in order to satisfy the monthly requirement.",
  "businessTerms.coupon.p4":
    "Activity exclusivity. Each activity, event, campaign, promotion or other offering (each, an \"Activity\") you publish on the platform must be offered exclusively through Uninfo HK. While an Activity is live on the platform (and for any period it is advertised or promoted by Uninfo HK), you must not publish, advertise, list or otherwise make the same Activity — or any substantially similar Activity — available on any other platform, marketplace, website, application, social media channel or physical outlet, whether free of charge or at the same or a different price. You must not publish, re-publish, recycle or reframe a previously offered Activity in order to satisfy any requirement under these Terms.",
  "businessTerms.coupon.p5":
    "Student-only audience. Each Coupon and Activity you publish on the platform must be made available only to verified university student users of Uninfo HK. You must not make the same Coupon or Activity — or any substantially similar Coupon or Activity — available to the general public or to any non-student audience through any other channel, whether at the same or a different price. Uninfo HK may require proof of student verification before redemption and may refuse, remove, suspend or terminate any Coupon or Activity that is made available to non-students.",
  "businessTerms.coupon.p6":
    "Failure to meet the minimum monthly requirement, or breach of any exclusivity or student-audience obligation above, is a material breach of these Terms. Uninfo HK may, at its sole discretion, charge you an additional fee of HKD 100 for each month in which you fail to meet the minimum requirement or breach such obligations, suspend or terminate your account and business services, withhold features, and refuse to renew your subscription, without refund of any fees already paid.",
  "businessTerms.cancellation.title": "6. Cancellation, Refunds & No-Refund Policy",
  "businessTerms.cancellation.p1":
    "You may cancel your subscription only after the first year of your subscription has ended. Cancellation may be requested through your account or by contacting us and will take effect at the end of the period you have already paid for, after which it will not renew.",
  "businessTerms.cancellation.p2":
    "All fees charged are non-refundable. We do not provide refunds or credits for partial periods, unused features, unpublished coupons or accounts you did not use, and cancellation does not relieve you of any fees already due.",
  "businessTerms.cancellation.p3":
    "Card validity and continued liability. You must keep a valid payment method on file. If your payment method expires, is replaced, is declined, or is otherwise invalid, we may suspend or restrict your account features. Suspension neither cancels your subscription nor releases you from fees: you remain liable for all platform fees and any coupon-shortfall fees accrued up to the date you cancel, including during the free first year. You must update your payment method promptly; unpaid amounts may be charged once a valid method is provided.",
  "businessTerms.latePayment.title": "7. Failed or Late Payment, Chargebacks & Suspension",
  "businessTerms.latePayment.p1":
    "If a payment fails, is overdue, or is reversed (including chargebacks or payment disputes), we may retry the charge and immediately suspend or restrict your account and business features until payment is successfully made. You remain responsible for all fees due plus any costs and reasonable administrative charges we incur in recovering them.",
  "businessTerms.obligations.title": "8. Business Obligations & Prohibited Content",
  "businessTerms.obligations.p1":
    "You agree to deal lawfully and in good faith with Uninfo HK and its users, and to honour all offers, coupons, discounts, Activities and redemptions you advertise on the platform. You must ensure that every Coupon and Activity is offered exclusively through Uninfo HK and only to verified university student users.",
  "businessTerms.obligations.p2":
    "You must not post unlawful, misleading, infringing, offensive or prohibited content, and must not misuse the platform, attempt to circumvent fees or interfere with its operation. You are solely responsible for your products, services, offers and compliance with all applicable laws.",
  "businessTerms.listings.title": "9. Listings, Content & Licence",
  "businessTerms.listings.p1":
    "You grant Uninfo HK a non-exclusive, worldwide, royalty-free licence to display, reproduce and promote your business name, logo, offers, images and other content you submit, solely for operating and promoting the platform. You represent that you own or have the right to use that content. Uninfo HK may, at its sole discretion, refuse, remove or edit any listing or content without notice. This content licence is non-exclusive as to your content; it does not limit the coupon and activity exclusivity or student-audience obligations in Section 5, under which each Coupon and Activity you publish must be offered exclusively through Uninfo HK and made available only to verified university students.",
  "businessTerms.platformRole.title": "10. Platform Role, No Guarantee & No Warranty",
  "businessTerms.platformRole.p1":
    "Uninfo HK is a marketplace that connects businesses with students and other users. The platform is provided on an \"as is\" and \"as available\" basis. We do not warrant that the service will be uninterrupted, secure or error-free, and we do not guarantee any minimum level of student participation, redemptions, traffic, revenue or results. Any use of the platform is at your own risk.",
  "businessTerms.liability.title": "11. Limitation of Liability",
  "businessTerms.liability.p1":
    "To the maximum extent permitted by law, Uninfo HK is not liable for any indirect, incidental, special, consequential or punitive damages, or for any loss of profits, revenue, data, goodwill or opportunity. Our total aggregate liability to you is limited to the greater of HKD 100 or the fees you paid to Uninfo HK in the one (1) month immediately preceding the event giving rise to the claim. We are not liable for the conduct of students or other users, or for any offer, product or service provided by you or any third party.",
  "businessTerms.indemnity.title": "12. Indemnity",
  "businessTerms.indemnity.p1":
    "You agree to indemnify, defend and hold harmless Uninfo HK, its affiliates, officers, employees and agents from and against any claims, losses, liabilities, damages, costs and expenses (including legal fees) arising out of your business, your offers, products or services, your content, or your breach of these Terms.",
  "businessTerms.termination.title": "13. Termination & Suspension by Uninfo HK",
  "businessTerms.termination.p1":
    "We may suspend or terminate your business account or access to the platform, with or without notice, if you breach these Terms, fail to pay any fees, fail to meet the minimum monthly coupon requirement, breach the coupon or activity exclusivity or student-audience obligations, misuse the platform, if required by law, or if we reasonably believe your continued use may harm the platform or its users. Fees already paid are non-refundable except where required by law.",
  "businessTerms.changes.title": "14. Changes, Modification & Discontinuation",
  "businessTerms.changes.p1":
    "We may update these Terms, and may modify, suspend or discontinue the platform or any feature, at any time and without liability. Material changes to the Terms will be posted on this page with a new version date, and your continued use of the platform after changes take effect constitutes acceptance of the updated Terms.",
  "businessTerms.general.title": "15. General",
  "businessTerms.general.p1":
    "You are solely responsible for obtaining and maintaining all licences, permits and approvals required for your business, and for paying all taxes arising from it. Nothing in these Terms creates any agency, partnership, employment or joint venture between you and Uninfo HK. We may assign or transfer these Terms without your consent. If any provision is found unenforceable, the remaining provisions continue in full force. These Terms (together with our general Terms of Service and Privacy Policy) are the entire agreement between you and Uninfo HK regarding the business services.",
  "businessTerms.governingLaw.title": "16. Governing Law & Jurisdiction",
  "businessTerms.governingLaw.p1":
    "These Terms are governed by the laws of the Hong Kong Special Administrative Region. You agree to submit to the exclusive jurisdiction of the courts of Hong Kong.",
  "businessTerms.contact.title": "17. Contact",
  "businessTerms.contact.p1":
    "For questions about these Terms, please contact us through our Contact page.",
  "Continue to card": "Continue to card",
  "Get started free": "Get started free",
  "Subscribe now": "Subscribe now",
  "Card validated": "Card validated",
  "Finalising registration…": "Finalising registration…",
  "Update card": "Update card",
  "Your payment method is invalid. Please update your card.":
    "Your payment method is invalid. Please update your card.",
  "Card updated": "Card updated",
  "Card valid": "Card valid",
  "Card invalid": "Card invalid",
  "No card on file": "No card on file",
  "First 100 · free year": "First 100 · free year",
  "Not in First 100": "Not in First 100",
  "Payment failed": "Payment failed",
  "Card removed": "Card removed",
  "Card expired": "Card expired",
  Status: "Status",
  "Account status": "Account status",
  "Activate business": "Activate business",
  "Deactivate business": "Deactivate business",
  "Renews on": "Renews on",
  "Ends on": "Ends on",
  "Free trial ends": "Free trial ends",
  "No subscription": "No subscription",
  "Resume subscription": "Resume subscription",
  "Cancel subscription": "Cancel subscription",
  "Manage in Stripe": "Manage in Stripe",
  "Minimum term": "Minimum term",
  "Cancel at": "Cancel at",
  Access: "Access",
  "Terminated instantly": "Terminated instantly",
  Trialing: "Trialing",
  "Past due": "Past due",
  Cancelled: "Cancelled",
  "No plan": "No plan",
  "Subscription terminated": "Subscription terminated",
  Reactivate: "Reactivate",
  "Business reactivated. The business can now choose a plan and re-subscribe.":
    "Business reactivated. The business can now choose a plan and re-subscribe.",
  "Activate this business?": "Activate this business?",
  "The business will be able to sign in and use the platform again.":
    "The business will be able to sign in and use the platform again.",
  "Deactivate this business?": "Deactivate this business?",
  "The business will be logged out and cannot sign in until it is activated again.":
    "The business will be logged out and cannot sign in until it is activated again.",
  Activate: "Activate",
  Deactivate: "Deactivate",
  "Reactivate this business?": "Reactivate this business?",
  "The subscription is reset so the business can choose a plan and re-subscribe. The saved card and promo stay on file.":
    "The subscription is reset so the business can choose a plan and re-subscribe. The saved card and promo stay on file.",
  "Cancel this subscription?": "Cancel this subscription?",
  "Resume this subscription?": "Resume this subscription?",
  "Auto-renewal is re-enabled and the business keeps its current period.":
    "Auto-renewal is re-enabled and the business keeps its current period.",
  "Manage in Stripe?": "Manage in Stripe?",
  "Open the Stripe Billing Portal in a new tab to update the card or manage the subscription.":
    "Open the Stripe Billing Portal in a new tab to update the card or manage the subscription.",
  Open: "Open",
  "Approve this business?": "Approve this business?",
  "Only the login flag changes. The subscription keeps running in Stripe, so renewals, platform fees and late fees are unaffected.":
    "Only the login flag changes. The subscription keeps running in Stripe, so renewals, platform fees and late fees are unaffected.",
  "Only the login flag changes. Subscription status and access stay exactly as they are.":
    "Only the login flag changes. Subscription status and access stay exactly as they are.",
  "The ended subscription is dropped, access unlocks right away and status becomes No plan. The original 12-month minimum term still applies.":
    "The ended subscription is dropped, access unlocks right away and status becomes No plan. The original 12-month minimum term still applies.",
  "Only the scheduled cancellation is cleared. Nothing is charged now and the price does not change.":
    "Only the scheduled cancellation is cleared. Nothing is charged now and the price does not change.",
  "This schedules the cancellation, it does not end the subscription now. The business keeps every paid feature and is still billed until the date above; only afterwards does Stripe end it and terminate access.":
    "This schedules the cancellation, it does not end the subscription now. The business keeps every paid feature and is still billed until the date above; only afterwards does Stripe end it and terminate access.",
  "This opens Stripe in another tab. Nothing in Uninfo changes until an update is made inside Stripe.":
    "This opens Stripe in another tab. Nothing in Uninfo changes until an update is made inside Stripe.",
  "The business is allowed to publish coupons, sponsors and activities. Billing still depends on having an active subscription.":
    "The business is allowed to publish coupons, sponsors and activities. Billing still depends on having an active subscription.",
  "Profile details": "Profile details",
  "The account flag only controls sign-in. Billing is managed in the Subscription section below.":
    "The account flag only controls sign-in. Billing is managed in the Subscription section below.",
  "Terminated instantly: the subscription ended, so all paid features are blocked. Use Reactivate to let the business choose a plan again.":
    "Terminated instantly: the subscription ended, so all paid features are blocked. Use Reactivate to let the business choose a plan again.",
  "I have read and agree to the Student Terms & Conditions and Privacy Policy": "I have read and agree to the Student Terms & Conditions and Privacy Policy",
  "Student Terms & Conditions": "Student Terms & Conditions",
  "Please accept the Student Terms & Conditions and Privacy Policy": "Please accept the Student Terms & Conditions and Privacy Policy",
  'Filter by date': 'Filter by date',
  'Filter by location': 'Filter by location',
  'Filter by hashtag': 'Filter by hashtag',
  'Any date': 'Any date',
  'Upcoming': 'Upcoming',
  'Next 7 days': 'Next 7 days',
  'Next 30 days': 'Next 30 days',
  'Past': 'Past',
  'Hashtag': 'Hashtag',
  'Any location': 'Any location',
  'Any hashtag': 'Any hashtag',
  'Applications open only': 'Applications open only',
}
